"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditBidderComponent = exports.ServerSide = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const forms_1 = require("@angular/forms");
const common_1 = require("@angular/common");
const router_1 = require("@angular/router");
const platform_browser_1 = require("@angular/platform-browser");
require("rxjs/add/operator/toPromise");
const bootstrap_1 = require("angular2-modal/plugins/bootstrap");
const angular2_modal_1 = require("angular2-modal");
//INTERNAL LIBRARY BITS
const user_service_1 = require("./user.service");
const permission_service_1 = require("./permission.service");
const bidder_service_1 = require("./bidder.service");
const demand_partner_service_1 = require("./demand-partner.service");
const demand_partner_type_service_1 = require("./demand-partner-type.service");
const version_service_1 = require("./version.service");
const clients_service_1 = require("./clients.service");
const notification_service_1 = require("./notification.service");
const check_key_pipe_1 = require("./check-key.pipe");
const version_pipe_1 = require("./version.pipe");
const size_service_1 = require("./size.service");
const price_bucket_service_1 = require("./price-bucket.service");
const loading_service_1 = require("./loading.service");
const integration_service_1 = require("./integration.service");
const can_deactivate_guard_service_1 = require("./can-deactivate-guard.service");
const demand_partner_menu_service_1 = require("./demand-partner-menu.service");
const order_by_pipe_1 = require("./order-by.pipe");
const dynamic_timeout_modal_component_1 = require("./dynamic-timeout-modal.component");
const notifier_service_1 = require("./notifier.service");
const lineitem_automation_component_1 = require("./lineitem-automation.component");
const changelog_service_1 = require("./changelog.service");
//VARIABLE MODELS
const ad_unit_1 = require("./ad-unit");
const bidder_1 = require("./bidder");
const demand_partner_1 = require("./demand-partner");
const touched_by_1 = require("./touched-by");
const version_1 = require("./version");
const changelog_modal_component_1 = require("./changelog-modal.component");
const events_1 = require("./events");
const ad_unit_service_1 = require("./ad-unit.service");
const branding_service_1 = require("./branding.service");
class ServerSide {
}
exports.ServerSide = ServerSide;
let EditBidderComponent = class EditBidderComponent {
    constructor(_decimalPipe, _versionPipe, _route, _bidder, _demandPartner, _demandPartnerType, _user, _permission, _v, _clients, _talk, _router, _checkKey, _cd, _af, _size, _priceBucket, _loading, _integration, _title, _demandPartnerMenu, _canDeactivateGuard, _notifier, _changeLog, modal, _location, _adUnits, _branding) {
        this._decimalPipe = _decimalPipe;
        this._versionPipe = _versionPipe;
        this._route = _route;
        this._bidder = _bidder;
        this._demandPartner = _demandPartner;
        this._demandPartnerType = _demandPartnerType;
        this._user = _user;
        this._permission = _permission;
        this._v = _v;
        this._clients = _clients;
        this._talk = _talk;
        this._router = _router;
        this._checkKey = _checkKey;
        this._cd = _cd;
        this._af = _af;
        this._size = _size;
        this._priceBucket = _priceBucket;
        this._loading = _loading;
        this._integration = _integration;
        this._title = _title;
        this._demandPartnerMenu = _demandPartnerMenu;
        this._canDeactivateGuard = _canDeactivateGuard;
        this._notifier = _notifier;
        this._changeLog = _changeLog;
        this.modal = modal;
        this._location = _location;
        this._adUnits = _adUnits;
        this._branding = _branding;
        //constants
        this.DEFAULT_PAGE_SIZE = 5;
        this.MIN_TIMEOUT = 100;
        this.MAX_TIMEOUT = 60000;
        //JSON OBJECT INFORMATION
        this.adUnits = [];
        this.server = {
            enabled: true,
            demandPartners: [],
        };
        this.userHoverIndex = -1;
        this.bidCPMAdjustments = [];
        this.schainPermission = false;
        this.schain = [];
        this.schainEnabled = true;
        this.schainSelection = [];
        this.schainFormModal = false;
        this.validationOption = ["strict", "relaxed", "off"]; // 0 index is a default value
        this.priceBuckets = [];
        this.adLock = false;
        this.typePermissions = 0;
        //other declarations for page
        this.demandPartners = [];
        this.clients = [];
        this.adEngineVersions = [];
        this.controlCenterVersions = [];
        this.selectedOptions = [];
        this.timeout = this._integration.getIntegration(1)["timeout"];
        this.hardFloor = this._integration.getIntegration(1)["hardFloor"] || 0;
        this.gptInstantLoad = this._integration.getIntegration(1)["gptInstantLoad"];
        this.internalRefresh = this._integration.getIntegration(1)["internalRefresh"];
        this.pubCommonId = this._integration.getIntegration(1)["pubCommonId"];
        this.enableServices = this._integration.getIntegration(1)["enableServices"];
        this.randomizeDemandPartner = this._integration.getIntegration(1)["randomizeDemandPartner"];
        this.dAUT = this._integration.getIntegration(1)["dAUT"];
        this.dAUTF = this._integration.getIntegration(1)["dAUTF"];
        this.onlyTargetSlotDivId = this._integration.getIntegration(1)["onlyTargetSlotDivId"];
        this.onlyTargetSlotCode = this._integration.getIntegration(1)["onlyTargetSlotCode"];
        this.instantAuction = this._integration.getIntegration(1)["instantAuction"];
        this.queRefresh = this._integration.getIntegration(1)["queRefresh"];
        this.adUnitHardFloor = this._integration.getIntegration(1)["adUnitHardFloor"];
        this.guaranteedRefresh = this._integration.getIntegration(1)["guaranteedRefresh"];
        this.immediateFirePixel = this._integration.getIntegration(1)["immediateFirePixel"];
        this.refreshOption = this._integration.getIntegration(1)["refreshOption"];
        this.waitForSlotDefinition = this._integration.getIntegration(1)["waitForSlotDefinition"];
        this.enableLineItemAutomation = this._integration.getIntegration(1)["enableLineItemAutomation"] || false;
        this.newUnitGeneration = this._integration.getIntegration(1)["newUnitGeneration"];
        this.castTAsInteger = this._integration.getIntegration(1)["castTAsInteger"];
        this.enforceGDPRDemandPartners = this._integration.getIntegration(1)["enforceGDPRDemandPartners"];
        this.enforceTCF2DemandPartners = this._integration.getIntegration(1)["enforceTCF2DemandPartners"];
        this.enforceCCPADemandPartners = this._integration.getIntegration(1)["enforceCCPADemandPartners"];
        this.sortChangelogList = "updatedAt";
        this.sortChangelogMod = true;
        this.bidderSaveRestriction = { status: "", restricted: false };
        this.biddr3x = this._integration.getIntegration(1)["biddr3x"] || true; //TODO: Research if still needed https://emxdigital.atlassian.net/browse/EMXD-1989
        this.biddr4 = this._integration.getIntegration(1)["biddr4"] || false;
        this.engine2pbMap = [];
        this.isCopy = false;
        this.showClients = false; //Client dropdown for organizations with multiple clients
        this.showAdEngineVersion = false; //Ad Engine dropdown to select version
        this.showControlCenterVersion = false; //Control Center dropdown to select version
        this.serverSideDisplay = true;
        this.adUnitsDisplay = true; //Show all ad unit info vs show minified ad unit info
        this.infoDisplay = true; //Show vs hide for Info tab
        this.advOptionsDisplay = false; //Show vs hide for Advanced Options tab
        this.priceBucketConfigDisplay = true;
        this.priceBucketReset = false;
        this.priceBucketEnumerate = false;
        this.pbE = [];
        this.priceBucketMenu = { reset: false };
        this.myOptions = this._size.get();
        this.lockLoad = false;
        this.saveState = false;
        this.showAllAdUnits = true;
        this.adUnitsPerPage = this.DEFAULT_PAGE_SIZE;
        this._router.routeReuseStrategy.shouldReuseRoute = () => false;
    }
    getBidder(bidderId) {
        if (bidderId) {
            this._route.data.subscribe((data) => {
                if (this.isCopy) {
                    // Make Changes in bidder while copying bidder
                    data.editBidderData.name = data.editBidderData.name + "_Copy";
                    if (data.editBidderData.integrations.enableLineItemAutomation)
                        this._talk.broadcast("While copying bidder file, please note that line items are not copied.");
                    data.editBidderData.integrations.enableLineItemAutomation = false;
                }
                this.selectedBidder = data.editBidderData;
            });
            this.setBidder();
            return this.selectedBidder, this.setBidder();
        }
        else {
            this.setBidder();
        }
    }
    setBidder() {
        this._title.setTitle(this._branding.getControlCenterTitle());
        this.adEngineVersions = this._v.getAllBiddrPlusVersions();
        this.controlCenterVersions = this._v.getAllControlCenterVersions();
        this.engine2pbMap = this._bidder.getEngine2pbMap();
        this.versions = {
            adEngine: this._v.getBiddrPlusVersion(),
            prebidVersion: this.engine2pbMap[this._v.getBiddrPlusVersion()],
            generator: this._v.getApplicationVersion(),
            controlCenter: this._v.getControlCenterVersion(),
        };
        this.permission = JSON.parse(JSON.stringify(this._permission.get()));
        this.schainPermission = !!(this.permission &&
            this.permission["control_center-schain_supported_demand_partners"]);
        this._cd.markForCheck();
    }
    ngOnInit() {
        this.createSchainForm();
        this._loading.start("Loading Bidder...");
        if (this._router.url.includes("/controlcenter/copy"))
            this.isCopy = true;
        this._route.params.forEach((param) => {
            this.bidderId =
                this._bidder.bidderId != 0 ? this._bidder.bidderId : +param["id"];
            this._bidder.bidderId = 0;
        });
        this.getBidder(this.bidderId);
        this.loadInitConfigs(this.bidderId);
        this._loading.stop();
    }
    copyBidder() {
        this._bidder.bidderId = this.bidderId;
        this._router.navigate(["controlcenter/copy"]);
    }
    ngAfterViewInit() {
        //Check for Query params, in case this was a redirect from a Pending Line Item Automation(LIA) notification
        this._route.queryParams
            .filter((params) => params["retryLiaVerify"])
            .subscribe((params) => {
            if (params["retryLiaVerify"]) {
                //We can call the save() method after all values were loaded so all existing values can be parsed and
                // LIA Verification gets trigger after successful saved.
                setTimeout(() => {
                    this.save();
                }, 0);
            }
        });
    }
    loadInitConfigs(bidderId) {
        this.getAllDemandPartners();
        this.typePermissions = this._demandPartnerType.permissionedTypes().length;
        //gets list of available clients, warns user if no clients are available
        this.clients = this._clients.get();
        if (this.clients.length < 1) {
            this._talk.broadcast(`Your organization currently has no clients and you will therefore be unable to create Bidders <i class="fa fa-frown-o" aria-hidden="true"></i><br><br>Please contact an administrator about this issue`);
        }
        return this._route.params.forEach((params) => {
            let id = +params["id"], bidder;
            //checks to see if bidder exists
            return Promise.resolve((bidder = this._bidder.getBidder(id || bidderId))).then((res) => {
                if (bidder) {
                    this.bidderSaveRestriction = this.verifyBidderState(this.selectedBidder);
                    if (!this.isCopy && this.bidderSaveRestriction.restricted)
                        this.displayBidderRestrictionAlert(this.bidderSaveRestriction, this.selectedBidder);
                    this.originalJson = this.selectedBidder;
                    this.loadBidder(this.selectedBidder);
                    this.loadBidderJson(this.selectedBidder);
                    if (!this.isCopy)
                        this.loadLineItemConfigValues(this.selectedBidder.id);
                }
                else {
                    this.createBidder();
                }
                this.loadControlCenterEvents();
            });
        });
    }
    loadControlCenterEvents() {
        this.events = new events_1.ControlCenterEvents({
            bidder: this.bidder.id,
            user: this._user.get().id,
        });
    }
    loadBidder(bidder) {
        this.bidder = bidder;
        this._changeLog.pullChangeLogByID(this.bidder.id);
        this.bidder.changeLog = [];
        if (this.bidder.lock) {
            this.adLock = this.isCopy ? false : this.bidder.lock.enabled;
        }
        this.bidder.client = this.bidder.client || this.clients[0];
    }
    loadBidderJson(bidder) {
        let bidderInfo = bidder;
        this.versions.adEngine = bidderInfo.engineVersion;
        this.versions.prebidVersion =
            bidderInfo.engine2pbMap[bidderInfo.engineVersion];
        this.versions.generator = bidderInfo.controlCenterVersion;
        this.versions.controlCenter = bidderInfo.controlCenterVersion
            ? bidderInfo.controlCenterVersion
            : "1.0.0";
        this.adUnits = [];
        if (bidderInfo.integrations.biddr3x !== undefined) {
            this.biddr3x = bidderInfo.integrations.biddr3x;
        }
        if (bidderInfo.integrations.biddr4 !== undefined) {
            this.biddr4 = bidderInfo.integrations.biddr4;
        }
        if (bidderInfo.integrations.dAUT !== undefined) {
            this.dAUT = bidderInfo.integrations.dAUT;
            this.dAUTF = bidderInfo.integrations.dAUTF;
        }
        if (bidderInfo.integrations.onlyTargetSlotDivId !== undefined) {
            this.onlyTargetSlotDivId = bidderInfo.integrations.onlyTargetSlotDivId;
        }
        if (bidderInfo.integrations.onlyTargetSlotCode !== undefined) {
            this.onlyTargetSlotCode = bidderInfo.integrations.onlyTargetSlotCode;
        }
        if (bidderInfo.integrations.instantAuction !== undefined) {
            this.instantAuction = bidderInfo.integrations.instantAuction;
        }
        if (bidderInfo.integrations.queRefresh !== undefined) {
            this.queRefresh = bidderInfo.integrations.queRefresh;
        }
        if (bidderInfo.integrations.guaranteedRefresh !== undefined) {
            this.guaranteedRefresh = bidderInfo.integrations.guaranteedRefresh;
        }
        if (bidderInfo.integrations.waitForSlotDefinition !== undefined) {
            this.waitForSlotDefinition =
                bidderInfo.integrations.waitForSlotDefinition;
        }
        if (bidderInfo.integrations.immediateFirePixel !== undefined) {
            this.immediateFirePixel = bidderInfo.integrations.immediateFirePixel;
        }
        if (bidderInfo.integrations.refreshOption !== undefined) {
            this.refreshOption = bidderInfo.integrations.refreshOption;
        }
        if (bidderInfo.integrations.enableLineItemAutomation !== undefined) {
            this.enableLineItemAutomation =
                bidderInfo.integrations.enableLineItemAutomation;
        }
        if (bidderInfo.integrations.waitForSlotDefinition !== undefined) {
            this.waitForSlotDefinition =
                bidderInfo.integrations.waitForSlotDefinition;
        }
        if (bidderInfo.integrations.gptInstantLoad !== undefined) {
            this.gptInstantLoad = bidderInfo.integrations.gptInstantLoad;
        }
        if (bidderInfo.integrations.newUnitGeneration !== undefined) {
            this.newUnitGeneration = bidderInfo.integrations.newUnitGeneration;
        }
        if (bidderInfo.integrations.castTAsInteger !== undefined) {
            this.castTAsInteger = bidderInfo.integrations.castTAsInteger;
        }
        if (bidderInfo.integrations.enforceGDPRDemandPartners !== undefined) {
            this.enforceGDPRDemandPartners =
                bidderInfo.integrations.enforceGDPRDemandPartners;
        }
        if (bidderInfo.integrations.enforceTCF2DemandPartners !== undefined) {
            this.enforceTCF2DemandPartners =
                bidderInfo.integrations.enforceTCF2DemandPartners;
        }
        if (bidderInfo.integrations.enforceCCPADemandPartners !== undefined) {
            this.enforceCCPADemandPartners =
                bidderInfo.integrations.enforceCCPADemandPartners;
        }
        this.integration = JSON.parse(JSON.stringify(this.bidder.client.integration));
        if (bidderInfo.integrations.adUnitHardFloor) {
            this.integration.adUnitHardFloor =
                bidderInfo.integrations.adUnitHardFloor;
        }
        if (typeof this.integration.adUnitHardFloor == "undefined")
            this.integration.adUnitHardFloor = false;
        for (let adU in bidderInfo.adUnits) {
            this.importAdUnit(bidderInfo.adUnits[adU]);
        }
        this.server = bidderInfo.server || {
            enabled: true,
            demandPartners: [],
        };
        this.bidder.createdBy = bidderInfo.createdBy || new touched_by_1.TouchedBy();
        if (bidderInfo.adUnits.length > this.DEFAULT_PAGE_SIZE * 2.5 &&
            this.permission &&
            this.permission["control_center-paginate_ad_units"]) {
            this.showAllAdUnits = false;
        }
        // if loading an invalid / old-style timeout, throw it away and use the default instead
        this.timeout = bidderInfo.timeout;
        if (typeof this.timeout !== "object") {
            this.timeout = {};
        }
        if (!this.timeout.staticTimeout) {
            this.timeout.staticTimeout = this.bidder.client.integration.staticTimeout;
        }
        if (!this.timeout.minTimeout) {
            this.timeout.minTimeout = this.bidder.client.integration.minTimeout;
        }
        if (!this.timeout.maxTimeout) {
            this.timeout.maxTimeout = this.bidder.client.integration.maxTimeout;
        }
        if (!this.timeout.fastBandwidth) {
            this.timeout.fastBandwidth = this.bidder.client.integration.fastBandwidth;
        }
        if (!this.timeout.slowBandwidth) {
            this.timeout.slowBandwidth = this.bidder.client.integration.slowBandwidth;
        }
        if (!this.timeout.type || this.timeout.type == "dynamic") {
            this.timeout.type = "dynamic";
            this.timeout.isStatic = false;
        }
        else if (this.timeout.type === "static") {
            this.timeout.isStatic = true;
        }
        this.hardFloor = bidderInfo.hardFloor;
        this.gptInstantLoad = bidderInfo.integrations.gptInstantLoad;
        this.enableServices = bidderInfo.integrations.enableServices;
        this.internalRefresh =
            bidderInfo.integrations.internalRefresh === undefined
                ? this.bidder.client.integration["internalRefresh"]
                : bidderInfo.integrations.internalRefresh;
        this.pubCommonId =
            bidderInfo.integrations.pubCommonId === undefined
                ? this.bidder.client.integration["pubCommonId"]
                : bidderInfo.integrations.pubCommonId;
        this.randomizeDemandPartner =
            bidderInfo.integrations.randomizeDemandPartner || false;
        this.bidCPMAdjustments = [];
        this.importBidCPMAdjustments(bidderInfo.bidAdjustments || {});
        if (this.schainPermission)
            this.importSchain(bidderInfo.schainConfig || {});
        if (!this.timeout.staticTimeout) {
            // default static
            this.timeout.staticTimeout = 1250;
        }
        if (bidderInfo.integrations.dAUT) {
            this.dAUT = bidderInfo.integrations.dAUT;
            this.dAUTF = bidderInfo.integrations.dAUTF;
        }
        if (bidderInfo.integrations.instantAuction) {
            this.instantAuction = bidderInfo.integrations.instantAuction;
        }
        this.priceBuckets = [];
        if (bidderInfo.priceBuckets) {
            for (let b in bidderInfo.priceBuckets) {
                this.importPriceBucket(bidderInfo.priceBuckets[b]);
            }
        }
        else {
            this.priceBuckets = this._priceBucket.getDefault();
        }
    }
    showChangeLogMenu() {
        var _a;
        if (this.bidder.changeLog.length < 1 &&
            typeof this.bidder.id != "undefined") {
            // Get savedAdUnits from originalJson if available
            const savedAdUnits = ((_a = this.originalJson) === null || _a === void 0 ? void 0 : _a.adUnits) || [];
            let newChangeLog = [];
            for (let adUnit in savedAdUnits) {
                let aUKey = Object.keys(savedAdUnits[adUnit]);
                for (let key in aUKey) {
                    // Map each change with context
                    const mappedChanges = this._changeLog
                        .getCurrentChangeLog()
                        .map((change) => {
                        change.oldVersion = change;
                        //For now defaulting versions to the latest current bidder if not found.
                        //until old data versions are migrated to proper fields
                        change.oldGenerator = new version_1.SemVer(change.controlCenterVersion || this.bidder.controlCenterVersion);
                        // Pass the correct context for oldAdEngine
                        let adEngineLength = Array.isArray(savedAdUnits[adUnit][aUKey[key]])
                            ? savedAdUnits[adUnit][aUKey[key]].length
                            : 0;
                        change.oldAdEngine = new version_1.SemVer(adEngineLength.toString());
                        change.updatedAt = moment
                            .utc(change.updatedAt)
                            .format("YYYY-MM-DD HH:mm");
                        return change;
                    });
                    newChangeLog = newChangeLog.concat(mappedChanges);
                }
            }
            this.bidder.changeLog = newChangeLog;
        }
        this.showMenu = !this.showMenu;
    }
    createBidder() {
        //CREATING A NEW BIDDER
        this.bidder = new bidder_1.Bidder();
        this.bidder.createdBy = new touched_by_1.TouchedBy();
        this.bidder.name = "";
        this.bidder.client = this.clients[0];
        this.integration = JSON.parse(JSON.stringify(this.bidder.client.integration));
        if (typeof this.integration.adUnitHardFloor == "undefined")
            this.integration.adUnitHardFloor = false;
        this.server = { enabled: true, demandPartners: [] };
        this.adUnits = [];
        this.setClient(this.bidder.client);
        this.timeout.type = "dynamic";
        this.timeout.isStatic = false;
        this.bidCPMAdjustments = [];
        this.schain = [];
        this.priceBuckets = this._priceBucket.getDefault();
    }
    canDeactivate() {
        var storeAdUnits = [];
        let modelChanges = "";
        if (this.permission &&
            this.permission["control_center-remove_change_detection"]) {
            return true;
        }
        if (this.originalJson) {
            for (let aU in this.adUnits) {
                let adUnit = this.adUnits[aU];
                var demandPartners = [];
                for (var mDP in adUnit.demandPartners.client) {
                    const fields = adUnit.demandPartners.client[mDP].fields;
                    var mDPP = {}; //output object for fields
                    for (var f in fields) {
                        if (fields[f].value) {
                            mDPP[fields[f].name] = fields[f].value;
                            switch (fields[f].type) {
                                case "numeric":
                                    mDPP[fields[f].name] = parseFloat(mDPP[fields[f].name]);
                                    break;
                                case "string":
                                    mDPP[fields[f].name] = mDPP[fields[f].name].toString();
                                    break;
                                case "object":
                                    mDPP[fields[f].name] = JSON.parse(JSON.stringify(mDPP[fields[f].name]));
                            }
                        }
                    }
                    demandPartners.push({
                        bidder: adUnit.demandPartners.client[mDP].code,
                        enabled: adUnit.demandPartners.client[mDP].enabled,
                        params: mDPP,
                    });
                }
                var serverBids = [];
                for (var mDP in adUnit.demandPartners.server) {
                    const fields = adUnit.demandPartners.server[mDP].fields;
                    var mDPP = {}; //output object for fields
                    for (var f in fields) {
                        if (fields[f].value) {
                            mDPP[fields[f].name] = fields[f].value;
                            switch (fields[f].type) {
                                case "numeric":
                                    mDPP[fields[f].name] = parseFloat(mDPP[fields[f].name]);
                                    break;
                                case "string":
                                    mDPP[fields[f].name] = mDPP[fields[f].name].toString();
                                    break;
                                case "object":
                                    mDPP[fields[f].name] = JSON.parse(JSON.stringify(mDPP[fields[f].name]));
                            }
                        }
                    }
                    serverBids.push({
                        bidder: adUnit.demandPartners.server[mDP].code,
                        enabled: adUnit.demandPartners.server[mDP].enabled,
                        params: mDPP,
                    });
                }
                if (typeof adUnit.sizeMapping != "undefined") {
                    adUnit.sizeMapping.devices = adUnit.sizeMapping.devices.map((val) => {
                        val.sizes = this._size.changeIdsToSizes(val.sizes);
                        return val;
                    });
                }
                storeAdUnits.push({
                    displayName: adUnit.displayName,
                    code: adUnit.code,
                    div: adUnit.div,
                    sizes: this._size.changeIdsToSizes(adUnit.sizes),
                    sizeMapping: adUnit.sizeMapping,
                    demandPartners: demandPartners,
                    serverBids: serverBids,
                    enabled: adUnit.enabled,
                    clientEnabled: adUnit.clientEnabled,
                    serverEnabled: adUnit.serverEnabled,
                });
            }
            var savedAdUnits = this.originalJson.adUnits;
            if (storeAdUnits.length != savedAdUnits.length) {
                console.error("Stored Ad Units: " + storeAdUnits.length);
                console.error("!=");
                console.error("Saved Ad Units: " + savedAdUnits.length);
                modelChanges += `<li>The number of Ad Units has changed</li>`;
            }
            else {
                allAdUnits: for (let adUnit in savedAdUnits) {
                    let aUKey = Object.keys(savedAdUnits[adUnit]);
                    for (let key in aUKey) {
                        if (JSON.stringify(savedAdUnits[adUnit][aUKey[key]]) !=
                            JSON.stringify(storeAdUnits[adUnit][aUKey[key]])) {
                            if (aUKey[key] == "demandPartners") {
                                if (storeAdUnits[adUnit][aUKey[key]].length !=
                                    Array.isArray(savedAdUnits[adUnit][aUKey[key]])
                                    ? Array.isArray(savedAdUnits[adUnit][aUKey[key]])
                                        ? savedAdUnits[adUnit][aUKey[key]]
                                            .length
                                        : 0
                                    : 0) {
                                    console.error(JSON.stringify(savedAdUnits[adUnit][aUKey[key]]));
                                    console.error("!=");
                                    console.error(JSON.stringify(storeAdUnits[adUnit][aUKey[key]]));
                                    modelChanges += `<li>Ad Units have unsaved changes</li>`;
                                    break allAdUnits;
                                }
                            }
                        }
                    }
                }
            }
            if (this.permission["control_center-view_demand_partners--server"]) {
                if (JSON.stringify(this.server) !==
                    JSON.stringify(this.originalJson["server"])) {
                    modelChanges += `<li>Server Side has unsaved changes</li>`;
                }
            }
            var cpmAdj = {};
            for (var bCPMA in this.bidCPMAdjustments) {
                if (this.bidCPMAdjustments[bCPMA].value != 100) {
                    cpmAdj[this.bidCPMAdjustments[bCPMA].code] =
                        this.bidCPMAdjustments[bCPMA].value;
                }
            }
            var tableAdj = this.originalJson.integrations["bidReductions"] || {};
            if (this.permission["control_center-view_demand_partners--server"] ==
                undefined) {
                delete tableAdj.server;
            }
            else if (tableAdj.server) {
                let serverAdj = JSON.parse(JSON.stringify(tableAdj.server));
                delete tableAdj.server;
                let serverAdjKeys = Object.keys(serverAdj);
                for (let adj in serverAdjKeys) {
                    tableAdj[serverAdjKeys[adj]] = serverAdj[serverAdjKeys[adj]];
                }
            }
            /*if (JSON.stringify(cpmAdj) != JSON.stringify(tableAdj)) {
              modelChanges += `<li>Bid CPM Adjustments have changed</li>`;
            }*/
            if (this.internalRefresh !==
                this.originalJson.integrations["internalRefresh"]) {
                modelChanges += `<li>Internal Refresh has changed</li>`;
            }
            if (this.pubCommonId !== this.originalJson.integrations["pubCommonId"]) {
                modelChanges += `<li>Publisher CommonId has changed</li>`;
            }
            if (this.gptInstantLoad !== this.originalJson.integrations["gptInstantLoad"]) {
                modelChanges += `<li>GPT Instant Load was changed</li>`;
            }
            if (this.enableServices !== this.originalJson.integrations["enableServices"]) {
                modelChanges += `<li>Enable Services was changed</li>`;
            }
            if (JSON.stringify(this.timeout) !==
                JSON.stringify(this.originalJson["timeout"]) &&
                typeof this.timeout == typeof this.originalJson["timeout"]) {
                modelChanges += `<li>Timeout was changed</li>`;
            }
            if (this.hardFloor !== this.originalJson["hardFloor"]) {
                modelChanges += `<li>Hard Floor was changed</li>`;
            }
            if (this.versions.adEngine !== this.originalJson.engineVersion) {
                modelChanges += `<li>Ad Engine Version was changed</li>`;
            }
            if (this.originalJson.integrations["randomizeDemandPartner"] == undefined &&
                this.randomizeDemandPartner)
                modelChanges += `<li>Randomize Demand Partner was changed</li>`;
            if (this.originalJson.integrations["randomizeDemandPartner"] != undefined) {
                if (this.randomizeDemandPartner !=
                    this.originalJson.integrations.randomizeDemandPartner) {
                    modelChanges += `<li>Randomize Demand Partner was changed</li>`;
                }
            }
            let savedPriceBuckets = this.originalJson.priceBuckets
                ? JSON.stringify(this.originalJson.priceBuckets.map((i) => {
                    return {
                        tier: i.min ? i.min : i.tier,
                        pbi: i.value ? i.value : i.pbi,
                    };
                }))
                : "";
            var pbCheck = JSON.stringify(this.priceBuckets.map((r) => {
                return { tier: r.tier, pbi: r.pbi };
            }));
            if (pbCheck != savedPriceBuckets) {
                modelChanges += `<li>Price Buckets were changed</li>`;
            }
        }
        else {
            if (this.bidder.name !== "" ||
                this.server.demandPartners.length > 0 ||
                this.adUnits.length > 0 ||
                !this.isDefaultTimeout() ||
                this.hardFloor !== this.bidder.client.integration["defaultHardFloor"] ||
                this.gptInstantLoad !==
                    this.bidder.client.integration["gptInstantLoad"] ||
                this.enableServices !==
                    this.bidder.client.integration["enableServices"] ||
                this.internalRefresh !==
                    this.bidder.client.integration["internalRefresh"] ||
                this.pubCommonId !== this.bidder.client.integration["pubCommonId"] ||
                this.randomizeDemandPartner !==
                    this.bidder.client.integration["randomizeDemandPartner"] ||
                this.bidCPMAdjustments.length > 0) {
                modelChanges += `<li>You've begun working on a new Bidder without saving it</li>`;
            }
        }
        if (modelChanges != "") {
            return this._talk
                .save(`You have unsaved changes:<br><ul>` +
                modelChanges +
                `</ul><br><br>Would you like to save before leaving this page?`)
                .then((resultPromise) => {
                if (resultPromise.result) {
                    return resultPromise.result.then((result) => {
                        if (typeof result != "undefined") {
                            if (result) {
                                return Promise.resolve(this.save()).then((r) => {
                                    if (r)
                                        return true;
                                    else
                                        return false;
                                });
                            }
                            return false;
                        }
                    });
                }
                return false;
            })
                .catch((err) => {
                return true;
            });
        }
        return true;
    }
    isDefaultTimeout() {
        return (this.timeout &&
            typeof this.timeout !== "object" &&
            this.timeout.staticTimeout ===
                this.bidder.client.integration.staticTimeout &&
            this.timeout.minTimeout === this.bidder.client.integration.minTimeout &&
            this.timeout.maxTimeout === this.bidder.client.integration.maxTimeout);
    }
    //Use view in ejs to access cdnpath for def file - in body tag of layout.ejs
    defFileLocation() {
        var t = document.body.dataset["cdnpath"];
        t = t.substring(1, t.length - 1);
        return t;
    }
    //AD UNIT CODE
    getAdUnitsPerPage() {
        return typeof this.adUnitsPerPage == "number" && this.adUnitsPerPage > 1
            ? this.adUnitsPerPage
            : this.DEFAULT_PAGE_SIZE;
    }
    addAdUnit() {
        this.events.add({
            subFeature: events_1.EventSubFeature.adUnit,
            action: events_1.EventAction.added,
        });
        var tempAdUnit = new ad_unit_1.AdUnit();
        if (this.adUnits.length > 0) {
            tempAdUnit.demandPartners = JSON.parse(JSON.stringify(this.adUnits[this.adUnits.length - 1].demandPartners));
            let dpTypes = Object.keys(tempAdUnit.demandPartners);
            for (let type in dpTypes) {
                for (var dp in tempAdUnit.demandPartners[dpTypes[type]]) {
                    delete tempAdUnit.demandPartners[dpTypes[type]][dp].adUnitPartnerId;
                    for (var field in tempAdUnit.demandPartners[dpTypes[type]][dp]
                        .fields) {
                        tempAdUnit.demandPartners[dpTypes[type]][dp].fields[field].value =
                            "";
                    }
                }
            }
        }
        else {
            tempAdUnit.demandPartners = new demand_partner_1.DemandPartners();
        }
        tempAdUnit.enabled = true;
        tempAdUnit.serverEnabled = true;
        tempAdUnit.clientEnabled = true;
        tempAdUnit.randomizeDemandPartner = true;
        tempAdUnit.code = "";
        tempAdUnit.sizes = [];
        tempAdUnit.sizeMapping = { activated: false, devices: [] };
        tempAdUnit.hardFloor = 0;
        this.adUnits.push(tempAdUnit);
    }
    importAdUnit(adUnitToImport) {
        let tempAdUnit = new ad_unit_1.AdUnit();
        tempAdUnit.id = this.isCopy ? null : adUnitToImport.id || null;
        tempAdUnit.guid = adUnitToImport.guid || null;
        tempAdUnit.displayName = adUnitToImport.displayName || "";
        tempAdUnit.code = adUnitToImport.code || "";
        tempAdUnit.div = adUnitToImport.div || "";
        tempAdUnit.sizes = adUnitToImport.sizes || [];
        tempAdUnit.hardFloor = parseFloat(adUnitToImport.hardFloor);
        if (adUnitToImport.sizeMapping) {
            let devices = adUnitToImport.sizeMapping.devices;
            for (let device in devices) {
                if (adUnitToImport.sizeMapping.devices[device].sizes != "undefined" &&
                    Array.isArray(adUnitToImport.sizeMapping.devices[device].sizes) &&
                    adUnitToImport.sizeMapping.devices[device].sizes.length > 0) {
                    devices[device].sizes = this._size.changeSizesToIds(devices[device].sizes);
                }
            }
            if (!adUnitToImport.sizeMapping.activated) {
                adUnitToImport.sizeMapping.activated = false;
            }
            tempAdUnit.sizeMapping = adUnitToImport.sizeMapping;
        }
        else {
            tempAdUnit.sizeMapping = { activated: false, devices: [] };
        }
        tempAdUnit.enabled =
            typeof adUnitToImport.enabled != "undefined"
                ? adUnitToImport.enabled
                : true;
        tempAdUnit.serverEnabled =
            typeof adUnitToImport.serverEnabled != "undefined"
                ? adUnitToImport.serverEnabled
                : true;
        tempAdUnit.clientEnabled =
            typeof adUnitToImport.clientEnabled != "undefined"
                ? adUnitToImport.clientEnabled
                : true;
        tempAdUnit.randomizeDemandPartner =
            typeof adUnitToImport.randomizeDemandPartner != "undefined"
                ? adUnitToImport.randomizeDemandPartner
                : true;
        //Normalize adUnits demand partner required fields
        const adUnitPartners = adUnitToImport.demandPartners && adUnitToImport.demandPartners.length
            ? adUnitToImport.demandPartners.map((partner) => {
                let { enabled, params, id, position } = partner;
                if (this.isCopy)
                    Object.keys(params).forEach((key) => (params[key] = ""));
                if (partner.demandPartner) {
                    return Object.assign(partner.demandPartner, {
                        enabled,
                        params,
                        adUnitPartnerId: this.isCopy ? null : id,
                        position,
                    });
                }
                return {};
            })
            : [];
        const dp = new demand_partner_1.DemandPartners();
        dp.client = adUnitPartners;
        dp.server = adUnitToImport.serverBids || [];
        tempAdUnit.demandPartners = this.importDemandPartners(dp);
        tempAdUnit.showDemandPartnerMenu = false;
        tempAdUnit.sizes = this._size.changeSizesToIds(tempAdUnit.sizes);
        this.adUnits.push(tempAdUnit);
    }
    removeAdUnit(ad) {
        this.adUnits.splice(ad, 1);
    }
    removeAdUnitX(ad) {
        let removeRequest = this._talk.confirm("Are you sure you want to delete this Ad Unit?");
        removeRequest.then((resultPromise) => {
            if (resultPromise.result)
                return resultPromise.result.then((result) => {
                    if (result)
                        return this.removeAdUnit(ad);
                });
        });
    }
    //DEMAND PARTNERS CODE
    //Gets all available Demand Partners then builds out their proper params as fields
    getAllDemandPartners() {
        return Promise.resolve(this._demandPartner.get()).then((demandPartners) => {
            this.demandPartners = demandPartners.reduce((partnerList, dP) => {
                if (this.permission["include-adapter--" + dP.code]) {
                    const paramObj = dP.params;
                    dP.fields = [];
                    for (var p in paramObj) {
                        dP.fields.push({
                            name: paramObj[p].paramName,
                            value: "",
                            required: paramObj[p].required,
                            type: paramObj[p].paramType,
                            subType: paramObj[p].subType,
                            minVersion: paramObj[p].minVersion,
                            maxVersion: paramObj[p].maxVersion,
                        });
                    }
                    partnerList.push(dP);
                }
                return partnerList;
            }, []);
        });
    }
    _cloneDemandPartner(partnerToAdd, type) {
        for (let demandPartner of this.demandPartners) {
            if (partnerToAdd &&
                demandPartner.code == partnerToAdd.code &&
                demandPartner.type.type == type) {
                let { adUnitPartnerId, params, position } = partnerToAdd;
                let values = Object.assign(Object.assign({}, demandPartner), { adUnitPartnerId, position, params });
                return JSON.parse(JSON.stringify(values));
            }
        }
        return new demand_partner_1.DemandPartner(); // If no matching demandPartner is found, return a blank one
    }
    importDemandPartners(demandPartnersToAdd) {
        let tempDemandPartners = new demand_partner_1.DemandPartners();
        let dpTypes = Object.keys(demandPartnersToAdd);
        for (let type in dpTypes) {
            let dpType = dpTypes[type];
            tempDemandPartners[dpType] = [];
            //sort partners by position
            demandPartnersToAdd[dpType] = this.sortArrayBy(demandPartnersToAdd[dpType], "position");
            for (let dPTA = demandPartnersToAdd[dpType].length - 1; dPTA > -1; dPTA--) {
                let tempDemandPartner = this._cloneDemandPartner(demandPartnersToAdd[dpType][dPTA], dpType);
                if (!tempDemandPartner.displayName) {
                    console.error("SAVED DEMAND PARTNER WITH NO DISPLAY NAME ");
                    console.error(tempDemandPartner);
                    continue;
                }
                //set enabled status: false used for available demand partners, true are shown to user as part of ad unit
                tempDemandPartner.enabled =
                    demandPartnersToAdd[dpType][dPTA].enabled || false;
                //import params to fields
                let params = demandPartnersToAdd[dpType][dPTA].params;
                if (tempDemandPartner.fields) {
                    for (let i = 0; i < tempDemandPartner.fields.length; i++) {
                        let field = tempDemandPartner.fields[i];
                        if (params.hasOwnProperty(field.name) &&
                            typeof params[field.name] != "undefined" &&
                            params[field.name] != "") {
                            field.value = Array.isArray(params[field.name])
                                ? JSON.stringify(params[field.name])
                                : params[field.name];
                        }
                    }
                }
                const totalDuplicatePartners = demandPartnersToAdd[dpType].filter((DP) => DP.code == tempDemandPartner.code).length;
                const totalDuplicatePartnersProcessed = tempDemandPartners[dpType].filter((tDP) => tDP.displayName == tempDemandPartner.displayName).length;
                // Calculate the duplicate number count for this partner
                tempDemandPartner.dpNum =
                    totalDuplicatePartners - totalDuplicatePartnersProcessed;
                tempDemandPartners[dpType].unshift(tempDemandPartner);
            }
        }
        return tempDemandPartners;
    }
    checkBidCPMAdjustmentsOnAdd(dP) {
        let demandPartner = JSON.parse(JSON.stringify(dP));
        let found = false;
        for (let cpm in this.bidCPMAdjustments) {
            if (demandPartner.code == this.bidCPMAdjustments[cpm].code) {
                found = true;
                break;
            }
        }
        if (!found) {
            this.bidCPMAdjustments.push({
                name: demandPartner.displayName || demandPartner.code,
                code: demandPartner.code,
                logo: demandPartner.logo,
                type: demandPartner.type,
                value: 100,
            });
        }
    }
    checkBidCPMAdjustmentOnRemove(demandPartnerToFind) {
        let found = false;
        var type = demandPartnerToFind.type.type;
        checkAll: for (let adUnit in this.adUnits) {
            for (let demandPartner in this.adUnits[adUnit].demandPartners[type]) {
                if (this.adUnits[adUnit].demandPartners[type][demandPartner].code ==
                    demandPartnerToFind.code &&
                    this.adUnits[adUnit].demandPartners[type][demandPartner].enabled) {
                    found = true;
                    break checkAll;
                }
            }
        }
        if (!found) {
            for (var bidCPM = 0; bidCPM < this.bidCPMAdjustments.length; bidCPM++) {
                if (this.bidCPMAdjustments[bidCPM].code == demandPartnerToFind.code &&
                    this.bidCPMAdjustments[bidCPM].type.type == type) {
                    this.bidCPMAdjustments.splice(bidCPM, 1);
                    break;
                }
            }
        }
        if (this.schainPermission)
            this.checkSchainAdjustmentsOnRemove(demandPartnerToFind);
    }
    checkSchainAdjustmentsOnAdd(dP) {
        let demandPartner = JSON.parse(JSON.stringify(dP));
        let found = this.schain.find((dP) => demandPartner.code == dP.code)
            ? true
            : false;
        if (this.schainPermission && !found && demandPartner.schain) {
            this.schain.push({
                code: demandPartner.code,
                config: this.schainForm.value,
                enabled: true,
                valid: false,
            });
        }
    }
    checkSchainAdjustmentsOnRemove(dP) {
        let found = false;
        var type = dP.type.type;
        checkAll: for (let adUnit in this.adUnits) {
            for (let demandPartner in this.adUnits[adUnit].demandPartners[type]) {
                if (this.adUnits[adUnit].demandPartners[type][demandPartner].code ===
                    dP.code &&
                    this.adUnits[adUnit].demandPartners[type][demandPartner].enabled) {
                    found = true;
                    break checkAll;
                }
            }
        }
        if (!found) {
            this.schain.forEach((val, index) => {
                if (val.code === dP.code) {
                    this.schain.splice(index, 1);
                }
            });
            // handle demand partner selection
            let selectedCodeIndex = this.schainSelection.indexOf(dP.code);
            if (selectedCodeIndex > -1) {
                this.schainSelection.slice(selectedCodeIndex, 1);
            }
        }
    }
    checkGptInstantLoad() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.gptInstantLoad ? events_1.EventAction.enabled : events_1.EventAction.disabled,
            subject: "gpt-instant-load",
        });
    }
    checkBiddr3x() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.biddr3x ? events_1.EventAction.enabled : events_1.EventAction.disabled,
            subject: "biddr-3x",
        });
        if (!this.biddr3x && !this.biddr4) {
            this.biddr4 = true;
            this.events.add({
                subFeature: events_1.EventSubFeature.advancedOption,
                action: this.biddr4 ? events_1.EventAction.enabled : events_1.EventAction.disabled,
                subject: "biddr-4",
            });
        }
    }
    checkBiddr4() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.biddr4 ? events_1.EventAction.enabled : events_1.EventAction.disabled,
            subject: "biddr-4",
        });
        if (!this.biddr3x && !this.biddr4) {
            this.biddr3x = true;
            this.events.add({
                subFeature: events_1.EventSubFeature.advancedOption,
                action: this.biddr3x ? events_1.EventAction.enabled : events_1.EventAction.disabled,
                subject: "biddr-3x",
            });
        }
    }
    checkEnableServices() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.enableServices ? events_1.EventAction.enabled : events_1.EventAction.disabled,
            subject: "enable-services",
        });
    }
    checkInternalRefresh() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.internalRefresh ? events_1.EventAction.enabled : events_1.EventAction.disabled,
            subject: "internal-refresh",
        });
    }
    checkPubCommonId() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.pubCommonId ? events_1.EventAction.enabled : events_1.EventAction.disabled,
            subject: "pub-cid",
        });
    }
    checkHollisticResequencer() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.randomizeDemandPartner
                ? events_1.EventAction.enabled
                : events_1.EventAction.disabled,
            subject: "randomize-demand-partner",
        });
    }
    //check to ensure that optional dynamic ad unit targeting is not turned on if the dynamic ad unit targeting feature itself is not turned on
    checkDAUT() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.dAUT ? events_1.EventAction.enabled : events_1.EventAction.disabled,
            subject: "dynamic-adunit-targeting",
        });
        if (!this.dAUT && this.dAUTF) {
            this.dAUTF = false;
            this.events.add({
                subFeature: events_1.EventSubFeature.advancedOption,
                action: this.dAUTF ? events_1.EventAction.enabled : events_1.EventAction.disabled,
                subject: "dynamic-adunit-targeting-fallback",
            });
        }
    }
    checkDAUTF() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.dAUTF ? events_1.EventAction.enabled : events_1.EventAction.disabled,
            subject: "dynamic-adunit-targeting-fallback",
        });
    }
    checkQueRefresh() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.queRefresh ? events_1.EventAction.enabled : events_1.EventAction.disabled,
            subject: "que-refresh",
        });
    }
    checkInstantAuction() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.instantAuction ? events_1.EventAction.enabled : events_1.EventAction.disabled,
            subject: "instant-auction",
        });
    }
    checkWaitForSlotDefinition() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.waitForSlotDefinition
                ? events_1.EventAction.enabled
                : events_1.EventAction.disabled,
            subject: "wait-for-slot-definition",
        });
    }
    checkGuaranteedRefresh() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.guaranteedRefresh
                ? events_1.EventAction.enabled
                : events_1.EventAction.disabled,
            subject: "guaranteed-refresh",
        });
    }
    checkImmediateFirePixel() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.immediateFirePixel
                ? events_1.EventAction.enabled
                : events_1.EventAction.disabled,
            subject: "immediate-fire-pixel",
        });
    }
    checkRefreshOption() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.refreshOption ? events_1.EventAction.enabled : events_1.EventAction.disabled,
            subject: "refresh-option",
        });
    }
    checkNewUnitGeneration() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.newUnitGeneration
                ? events_1.EventAction.enabled
                : events_1.EventAction.disabled,
            subject: "newUnitGeneration",
        });
    }
    checkCastTAsInteger() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.castTAsInteger ? events_1.EventAction.enabled : events_1.EventAction.disabled,
            subject: "castTAsInteger",
        });
    }
    checkEnforceGDPRDemandPartners() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.enforceGDPRDemandPartners
                ? events_1.EventAction.enabled
                : events_1.EventAction.disabled,
            subject: "enforceGDPRDemandPartners",
        });
        if (this.enforceGDPRDemandPartners && this.enforceTCF2DemandPartners) {
            this.enforceTCF2DemandPartners = false;
            this.events.add({
                subFeature: events_1.EventSubFeature.advancedOption,
                action: this.onlyTargetSlotCode
                    ? events_1.EventAction.enabled
                    : events_1.EventAction.disabled,
                subject: "enforceTCF2DemandPartners",
            });
        }
    }
    checkEnforceTCF2DemandPartners() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.enforceTCF2DemandPartners
                ? events_1.EventAction.enabled
                : events_1.EventAction.disabled,
            subject: "enforceTCF2DemandPartners",
        });
        if (this.enforceTCF2DemandPartners && this.enforceGDPRDemandPartners) {
            this.enforceGDPRDemandPartners = false;
            this.events.add({
                subFeature: events_1.EventSubFeature.advancedOption,
                action: this.onlyTargetSlotCode
                    ? events_1.EventAction.enabled
                    : events_1.EventAction.disabled,
                subject: "enforceGDPRDemandPartners",
            });
        }
    }
    checkEnforceCCPADemandPartners() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.enforceCCPADemandPartners
                ? events_1.EventAction.enabled
                : events_1.EventAction.disabled,
            subject: "enforceCCPADemandPartners",
        });
    }
    //CLIENT CODE
    setClient(client) {
        this.bidder.client = client;
        if (!this.bidder.iID) {
            this.enableLineItemAutomation =
                this.bidder.client.integration["enableLineItemAutomation"];
            let { staticTimeout, maxTimeout, minTimeout, fastBandwidth, slowBandwidth, } = this.bidder.client.integration;
            this.timeout = {
                staticTimeout,
                maxTimeout,
                minTimeout,
                fastBandwidth,
                slowBandwidth,
            };
            this.timeout.staticTimeout =
                this.bidder.client.integration["staticTimeout"];
            this.timeout.minTimeout = this.bidder.client.integration["minTimeout"];
            this.timeout.maxTimeout = this.bidder.client.integration["maxTimeout"];
            this.adUnitHardFloor = this.bidder.client.integration["adUnitHardFloor"];
            this.gptInstantLoad = this.bidder.client.integration["gptInstantLoad"];
            this.enableServices = this.bidder.client.integration["enableServices"];
            this.internalRefresh = this.bidder.client.integration["internalRefresh"];
            this.pubCommonId = this.bidder.client.integration["pubCommonId"];
            this.randomizeDemandPartner =
                this.bidder.client.integration["randomizeDemandPartner"];
            this.dAUT = this.bidder.client.integration["dAUT"];
            this.dAUTF = this.bidder.client.integration["dAUTF"];
            this.queRefresh = this.bidder.client.integration["queRefresh"];
            this.onlyTargetSlotDivId =
                this.bidder.client.integration["onlyTargetSlotDivId"];
            this.onlyTargetSlotCode =
                this.bidder.client.integration["onlyTargetSlotCode"];
            this.instantAuction = this.bidder.client.integration["instantAuction"];
            this.waitForSlotDefinition =
                this.bidder.client.integration["waitForSlotDefinition"];
            this.guaranteedRefresh =
                this.bidder.client.integration["guaranteedRefresh"];
            this.immediateFirePixel =
                this.bidder.client.integration["immediateFirePixel"];
            this.refreshOption = this.bidder.client.integration["refreshOption"];
            this.newUnitGeneration =
                this.bidder.client.integration["newUnitGeneration"];
            this.castTAsInteger = this.bidder.client.integration["castTAsInteger"];
            this.enforceGDPRDemandPartners =
                this.bidder.client.integration["enforceGDPRDemandPartners"];
            this.enforceTCF2DemandPartners =
                this.bidder.client.integration["enforceTCF2DemandPartners"];
            this.enforceCCPADemandPartners =
                this.bidder.client.integration["enforceCCPADemandPartners"];
        }
        this.showClients = false;
    }
    //VERSIONS CODE
    setAdEngineVersion(v) {
        this.versions.adEngine = v;
        this.versions.prebidVersion = this.engine2pbMap[v];
        this.showAdEngineVersion = false;
    }
    setControlCenterVersion(v) {
        this.versions.controlCenter = v;
        this.showControlCenterVersion = false;
    }
    //HARD FLOOR CODE
    changeHardFloorGranularity() {
        this.integration.adUnitHardFloor = !this.integration.adUnitHardFloor;
        if (this.integration.adUnitHardFloor) {
            if (this.allAdUnitHardFloorsNotSet() && this.hardFloor != 0) {
                this._talk
                    .confirm(`You currently have no Hard Floors set on the Ad Unit level, would you like to migrate your current Bidder Hard Floor ` +
                    this.hardFloor +
                    ` to be used as your Ad Unit's Hard Floor to start?`)
                    .then((dialog) => dialog.result)
                    .then(() => {
                    this.adUnits = this.adUnits.map((adUnit) => {
                        adUnit.hardFloor = this.hardFloor;
                        return adUnit;
                    });
                })
                    .catch((err) => {
                    if (err)
                        console.log(err);
                });
            }
        }
        else {
            if (this.bidderHardFloorNotSet()) {
                let mostUsedHardFloor = this.getMostUsedAdUnitHardFloor();
                if (mostUsedHardFloor) {
                    this._talk
                        .confirm(`You currently have no Hard Floor set on the Bidder level, would you like to migrate your most used Ad Unit Hard Floor ` +
                        mostUsedHardFloor +
                        ` to be used as your Bidder Hard Floor?`)
                        .then((dialog) => dialog.result)
                        .then(() => {
                        this.hardFloor = parseFloat(mostUsedHardFloor);
                    })
                        .catch((err) => {
                        if (err)
                            console.log(err);
                    });
                }
            }
        }
    }
    pbEvent(data) {
        this.priceBuckets = data;
    }
    allAdUnitHardFloorsNotSet() {
        return (this.adUnits.filter((adUnit) => {
            return adUnit.hardFloor && adUnit.hardFloor != 0;
        }).length < 1);
    }
    bidderHardFloorNotSet() {
        return typeof this.hardFloor != "undefined" && this.hardFloor == 0;
    }
    getMostUsedAdUnitHardFloor() {
        let arr = this.adUnits.map((adUnit) => {
            return JSON.stringify(adUnit.hardFloor);
        });
        arr = arr.filter((arr) => {
            return arr != "null" && arr != "0";
        });
        return arr
            .sort((a, b) => arr.filter((v) => v === a).length - arr.filter((v) => v === b).length)
            .pop();
    }
    //INTEGRATIONS CODE
    timeoutHelp() {
        this.modal
            .open(dynamic_timeout_modal_component_1.DynamicTimeoutModalComponent, (0, angular2_modal_1.overlayConfigFactory)({ isBlocking: true }))
            .then((err) => {
            console.log(err);
        });
    }
    hardFloorHelp() {
        this._talk.broadcast("Your Hard Floor price can be activated across your entire Bidder File or on individual Ad Units. The Hard Floor represents the minimum price to win a bid. If bids are below the Hard Floor, then no bid wins the header bidding auction. When bids are at or above the Hard Floor, normal auction dynamics will apply. If Hard Floor is on the Bidder level, the input value will be used across all Ad Units. If Hard Floor is on the Ad Unit level, a value will need to be input on each Ad Unit to be applied to that specific Ad Unit (any Ad Units without a Hard Floor value will not have a Hard Floor applied.");
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "hard-floor",
        });
    }
    integrationsHelp() {
        this._talk.broadcast("Integrations are optional changes to the Bidder file generated to build custom integration types. These different choices help to customize the solution to allow for specialty code to enhance the Bidder's functionality.");
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "integrations",
        });
    }
    gptInstantLoadHelp() {
        this._clients.gptInstantLoadHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "gpt-instant-load",
        });
    }
    biddr3xHelp() {
        this._talk.broadcast("Enable Biddr 3X Endpoint Integration");
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "biddr-3x",
        });
    }
    biddr4Help() {
        this._talk.broadcast("Enable Biddr 4 Endpoint Integration");
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "biddr-4",
        });
    }
    enableServicesHelp() {
        this._clients.enableServicesHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "enable-services",
        });
    }
    internalRefreshHelp() {
        this._clients.internalRefreshHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "internal-refresh",
        });
    }
    pubCommonIdHelp() {
        this._clients.pubCommonIdHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "pub-cid",
        });
    }
    holisticResequencerHelp() {
        this._clients.holisticResequencerHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "randomize-demand-partner",
        });
    }
    dynamicAdUnitTargetingHelp() {
        this._clients.dynamicAdUnitTargetingHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "dynamic-adunit-targeting",
        });
    }
    dynamicAdUnitTargetingFallbackHelp() {
        this._clients.dynamicAdUnitTargetingFallbackHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "dynamic-adunit-targeting-fallback",
        });
    }
    targetAdUnitDivIDHelp() {
        this._clients.targetAdUnitDivIDHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "only-target-slot-div-id",
        });
    }
    targetAdUnitCodeHelp() {
        this._clients.targetAdUnitCodeHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "only-target-slot-code",
        });
    }
    instantAuctionHelp() {
        this._clients.instantAuctionHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "instant-auction",
        });
    }
    queRefreshHelp() {
        this._talk.broadcast("Selecting Que Refresh adds a Queing system to calling reset. Without this feature, if reset is called while an auction is taking place, it will immediately start a new auction. With this feature, the initial auction will finish and then the next auction started by reset will occur.");
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "que-refresh",
        });
    }
    waitForSlotDefinitionHelp() {
        this._clients.waitForSlotDefinitionHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "wait-for-slot-definition",
        });
    }
    enableLineItemAutomationHelp() {
        this._talk.broadcast("Selecting Enable Line Item Automation allows to sync all line items with DFP automatically whenever there is new line item config changes.");
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "enable-line-item-automation",
        });
    }
    //BID CPM ADJUSTMENT CODE
    bidCPMAdjustmentHelp() {
        this._talk.broadcast("Bid CPM Adjustments allow you to send your ad server a multiple of the bid you have received from a demand partner. This is helpful for adjusting bids for rev share agreements. Bid CPM Adjustments must be input in percentage format. For example, if your revenue share deal with a Demand Partner is 80/20, your Bid CPM Adjustment should be input as 80% under that respective Demand Partner. By default, all of your eligible demand partners in your stack will appear with a Bid CPM Adjustment of 100%, meaning 100% of the bid price will be passed. Adjustments can be made accordingly based on your agreement with your respective demand partner(s).");
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "bid-cpm-adjustment",
        });
    }
    guaranteedRefreshHelp() {
        this._clients.guaranteedRefreshHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "guaranteed-refresh",
        });
    }
    immediateFirePixelHelp() {
        this._clients.immediateFirePixelHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "immediate-fire-pixel",
        });
    }
    refreshOptionHelp() {
        this._clients.refreshOptionHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "refresh-option",
        });
    }
    newUnitGenerationHelp() {
        this._clients.newUnitGenerationHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "new-unit-generation",
        });
    }
    castTAsIntegerHelp() {
        this._clients.castTAsIntegerHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "cast-t-as-integer",
        });
    }
    enforceGDPRDemandPartnersHelp() {
        this._clients.enforceGDPRDemandPartnersHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "enforce-gdpr-demand-partners",
        });
    }
    enforceCCPADemandPartnersHelp() {
        this._clients.enforceCCPADemandPartnersHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "enforce-ccpa-demand-partners",
        });
    }
    enforceTCF2DemandPartnersHelp() {
        this._clients.enforceTCF2DemandPartnersHelp();
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "enforce-tcf2-demand-partners",
        });
    }
    toggleTimeoutType(timeout) {
        timeout.isStatic = !timeout.isStatic;
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            subject: timeout.isStatic ? "static" : "dynamic",
            action: events_1.EventAction.toggled,
        });
    }
    toggleAdvancedOptions() {
        this.advOptionsDisplay = !this.advOptionsDisplay;
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.advOptionsDisplay
                ? events_1.EventAction.expanded
                : events_1.EventAction.collapsed,
        });
    }
    getAdapterCpmValue(adapter = "brealtime") {
        for (let cpm in this.bidCPMAdjustments) {
            // RTbx should have same brealtime value
            if (this.bidCPMAdjustments[cpm].code === adapter) {
                return { value: this.bidCPMAdjustments[cpm].value, found: true, cpm };
            }
        }
        return {};
    }
    importBidCPMAdjustments(bidCPMAdjustments) {
        var bidderKeys = Object.keys(bidCPMAdjustments) || [];
        var bidderServerKeys = typeof bidCPMAdjustments.server != "undefined"
            ? Object.keys(bidCPMAdjustments.server)
            : [];
        var types = ["client", "server"];
        for (let aU in this.adUnits) {
            for (let t in types) {
                for (let dp in this.adUnits[aU].demandPartners[types[t]]) {
                    if (this.bidCPMAdjustments.filter((cpm) => {
                        return (cpm.code == this.adUnits[aU].demandPartners[types[t]][dp].code);
                    }).length < 1) {
                        this.bidCPMAdjustments.push({
                            name: this.adUnits[aU].demandPartners[types[t]][dp].displayName,
                            code: this.adUnits[aU].demandPartners[types[t]][dp].code,
                            logo: this.adUnits[aU].demandPartners[types[t]][dp].logo,
                            type: this.adUnits[aU].demandPartners[types[t]][dp].type,
                            value: 100,
                        });
                    }
                }
            }
        }
        for (let key in bidderKeys) {
            for (let cpm in this.bidCPMAdjustments) {
                if (this.bidCPMAdjustments[cpm].code == bidderKeys[key] &&
                    this.bidCPMAdjustments[cpm].type.type == "client") {
                    bidCPMAdjustments[bidderKeys[key]] =
                        bidCPMAdjustments[bidderKeys[key]] == 0
                            ? 1
                            : bidCPMAdjustments[bidderKeys[key]];
                    this.bidCPMAdjustments[cpm].value =
                        bidCPMAdjustments[bidderKeys[key]] * 100;
                    this._af.tick();
                    break;
                }
            }
        }
        for (let dP in this.server.demandPartners) {
            if (this.bidCPMAdjustments.filter((cpm) => {
                return (cpm.code == this.server.demandPartners[dP].code &&
                    cpm.type == this.server.demandPartners[dP].type);
            }).length < 1) {
                this.bidCPMAdjustments.push({
                    name: this.server.demandPartners[dP].displayName,
                    code: this.server.demandPartners[dP].code,
                    logo: this.server.demandPartners[dP].logo,
                    type: this.server.demandPartners[dP].type,
                    value: 100,
                });
            }
        }
        for (let key in bidderServerKeys) {
            for (let cpm in this.bidCPMAdjustments) {
                if (this.bidCPMAdjustments[cpm].code == bidderServerKeys[key] &&
                    this.bidCPMAdjustments[cpm].type.type == "server") {
                    this.bidCPMAdjustments[cpm].value =
                        bidCPMAdjustments.server[bidderServerKeys[key]] * 100;
                    this._af.tick();
                    break;
                }
            }
        }
    }
    switchAdLock() {
        this.lockLoad = true;
        this.adLock = !this.adLock;
        // Update bidder save restriction state, if locked
        if (this.bidderSaveRestriction &&
            this.bidderSaveRestriction.status === "locked")
            this.bidderSaveRestriction.restricted = this.adLock;
        this._bidder.adLock(this.bidder.id, this.adLock).then((success) => {
            this.lockLoad = false;
        });
    }
    checkTargetSlotDivID() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.onlyTargetSlotDivId
                ? events_1.EventAction.enabled
                : events_1.EventAction.disabled,
            subject: "only-target-slot-div-id",
        });
        if (this.onlyTargetSlotDivId && this.onlyTargetSlotCode) {
            this.onlyTargetSlotCode = false;
            this.events.add({
                subFeature: events_1.EventSubFeature.advancedOption,
                action: this.onlyTargetSlotCode
                    ? events_1.EventAction.enabled
                    : events_1.EventAction.disabled,
                subject: "only-target-slot-code",
            });
        }
    }
    checkTargetSlotCode() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            action: this.onlyTargetSlotCode
                ? events_1.EventAction.enabled
                : events_1.EventAction.disabled,
            subject: "only-target-slot-code",
        });
        if (this.onlyTargetSlotCode && this.onlyTargetSlotDivId) {
            this.onlyTargetSlotDivId = false;
            this.events.add({
                subFeature: events_1.EventSubFeature.advancedOption,
                action: this.onlyTargetSlotDivId
                    ? events_1.EventAction.enabled
                    : events_1.EventAction.disabled,
                subject: "only-target-slot-div-id",
            });
        }
    }
    //PRICE BUCKET CODE
    importPriceBucket(priceBucketToImport) {
        this.priceBuckets.push({
            tier: JSON.parse(JSON.stringify(priceBucketToImport.min)),
            pbi: JSON.parse(JSON.stringify(priceBucketToImport.value)),
        });
    }
    priceBucketHelp() {
        this._talk.broadcast("Price Buckets allow you to specify the granularity/interval of the bids that Biddr360 will send to your ad server. You can easily adjust intervals between dollar amounts that best suit your preferences. For example, if you group bids in 10 cent increments, then bids that come in at $1.16 or $1.12 would be rounded down into a single price bucket of $1.10. Please note that your price buckets inside of the Control Center do not reflect the line items in your instance of DFP, so you need to create individual line items inside of DFP to reflect the price buckets in order to activate this feature.");
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "price-bucket",
        });
    }
    showPriceBucketMenu() {
        this.priceBucketMenu.reset = true;
    }
    save(showSavedAlert = true) {
        //FORM VALIDATION
        //let dpTypes=Object.keys(new DemandPartners);
        var dpTypes = ["server", "client"];
        var modelWarnings = ``;
        var hardFloorNotification = false;
        var sizeGUIDs = this._size.get().map((s) => {
            return { guid: s.guid, name: s.name };
        });
        var demandPartnerGUIDs = this._demandPartner.getGUID();
        if (!this.bidder.name) {
            modelWarnings += ` <li>The Bidder currently is not named</li>`;
        }
        if (this.adUnits.filter((adU) => {
            return adU.enabled;
        }).length < 1) {
            modelWarnings +=
                `<li>` +
                    this.bidder.name +
                    ` needs to have at least one Enabled Ad Unit</li>`;
        }
        for (let adUnit of this.adUnits) {
            if (!adUnit.displayName) {
                adUnit.displayName = adUnit.code || "AdUnit #" + adUnit;
                modelWarnings += `<li>${adUnit.displayName} was missing a name, it has been set to ${adUnit.displayName}</li>`;
            }
            if (this.adUnits.filter((r) => {
                return adUnit.displayName == r.displayName;
            }).length > 1) {
                modelWarnings +=
                    `<li>` + adUnit.displayName + ` does not have a unique name.</li>`;
            }
            if (!adUnit.div) {
                modelWarnings +=
                    `<li>` + adUnit.displayName + ` is missing a div identifier</li>`;
            }
            if (!adUnit.code) {
                modelWarnings += `<li>${adUnit.displayName} is missing a code identifier</li>`;
            }
            if (adUnit.sizeMapping && adUnit.sizeMapping.activated) {
                let used = false;
                for (let d in adUnit.sizeMapping.devices) {
                    if (adUnit.sizeMapping.devices[d].sizes.length > 0) {
                        used = true;
                        break;
                    }
                }
                if (!used) {
                    modelWarnings += `<li>${adUnit.displayName} needs to have at least one device with a size mapping option enabled. If you do not want to use Size Mapping, please change ${adUnit.displayName} to use "Static" sizing instead.</li>`;
                }
            }
            else {
                if (!(adUnit.sizes && adUnit.sizes.length > 0)) {
                    modelWarnings += `<li>${adUnit.displayName} needs to have at least one size</li>`;
                }
            }
            if (!adUnit.clientEnabled &&
                !adUnit.serverEnabled &&
                !(this.server.enabled && this.server.demandPartners.length > 0)) {
                modelWarnings += `<li>${adUnit.displayName} needs to have at least one type of Demand Partner Enabled</li>`;
            }
            if (((!adUnit.clientEnabled &&
                adUnit.demandPartners.server.filter((adU) => {
                    return adU.enabled;
                }).length < 1) ||
                (!adUnit.serverEnabled &&
                    adUnit.demandPartners.client.filter((adU) => {
                        return adU.enabled;
                    }).length < 1)) &&
                !(this.server.enabled && this.server.demandPartners.length > 0)) {
                modelWarnings += `<li>${adUnit.displayName} needs to have at least one enabled Demand Partner</li>`;
            }
            let totalDP = 0;
            for (let curDPType in dpTypes) {
                for (let partner of adUnit.demandPartners[dpTypes[curDPType]]) {
                    if (partner.enabled) {
                        let fields = partner.fields && partner.fields.length > 0
                            ? JSON.parse(JSON.stringify(this._versionPipe.transform(partner.fields, this.versions.adEngine)))
                            : [];
                        for (let field in fields) {
                            if (fields[field].required || fields[field].value) {
                                if (typeof fields[field].value == "undefined" ||
                                    fields[field].value == "") {
                                    modelWarnings += `<li>${adUnit.displayName}'s Demand Partner "${partner.displayName}" is missing a required field ${fields[field].name}</li>`;
                                }
                                else {
                                    switch (fields[field].type) {
                                        case "boolean":
                                            if (fields[field].value != "true" &&
                                                fields[field].value != "false") {
                                                modelWarnings += `<li>${adUnit.displayName}'s Demand Partner "${partner.displayName}" had a field ${fields[field].name} that should be a boolean but is not</li>`;
                                            }
                                            break;
                                        case "numeric":
                                            if (parseFloat(fields[field].value) != fields[field].value) {
                                                modelWarnings += `<li>${adUnit.displayName}'s Demand Partner "${partner.displayName}" had a field ${fields[field].name} that should be a number but is not</li>`;
                                            }
                                            break;
                                        case "object":
                                            if (!(Object.keys(JSON.parse(fields[field].value)).length >
                                                0)) {
                                                modelWarnings += `<li>${adUnit.displayName}'s Demand Partner "${partner.displayName}" had a field ${fields[field].name} that should be an object{} but is not</li>`;
                                            }
                                            break;
                                        case "array":
                                            try {
                                                JSON.parse(fields[field].value);
                                            }
                                            catch (e) {
                                                modelWarnings += `<li>${adUnit.displayName}'s Demand Partner "${partner.displayName}" had a field ${fields[field].name} that should be an array[] of ${fields[field].subType} but is not</li>`;
                                                break;
                                            }
                                            const arrVal = JSON.parse(fields[field].value);
                                            if (!Array.isArray(arrVal) ||
                                                !(arrVal.length || arrVal.length > 0)) {
                                                modelWarnings += `<li>${adUnit.displayName}'s Demand Partner "${partner.displayName}" had a field ${fields[field].name} that should be an array[] but is not</li>`;
                                            }
                                            else {
                                                for (let val in arrVal) {
                                                    switch (fields[field].subType) {
                                                        case "numeric":
                                                            if (parseFloat(arrVal[val]) != arrVal[val]) {
                                                                modelWarnings += `<li>${adUnit.displayName}'s Demand Partner "${partner.displayName}" had a field ${fields[field].name} that should be a number but is not</li>`;
                                                            }
                                                            break;
                                                        case "string":
                                                            if (typeof arrVal[val] != "string") {
                                                                modelWarnings += `<li>${adUnit.displayName}'s Demand Partner "${partner.displayName}" had a field ${fields[field].name} that should be a string but is not</li>`;
                                                            }
                                                            break;
                                                        case "object":
                                                            if (!Object.keys(JSON.parse(arrVal[val]).length > 0)) {
                                                                modelWarnings += `<li>${adUnit.displayName}'s Demand Partner "${partner.displayName}" had a field ${fields[field].name} that should be an object{} but is not</li>`;
                                                            }
                                                            break;
                                                    }
                                                }
                                            }
                                            break;
                                    }
                                }
                            }
                        }
                    }
                }
                totalDP += adUnit.demandPartners[dpTypes[curDPType]].filter((i) => i.enabled).length;
            }
            if (totalDP < 1 && adUnit.enabled) {
                modelWarnings += `<li>${adUnit.displayName} needs to have at least one Demand Partner enabled</li>`;
            }
        }
        this.schain.forEach((dP, si) => {
            if (parseInt(dP.config.hp) == dP.config.hp) {
                this.schain[si].config.hp = parseInt(dP.config.hp);
            }
            else {
                this.schain[si].config.hp = null;
            }
            if (parseInt(dP.config.complete) == dP.config.complete) {
                this.schain[si].config.complete = parseInt(dP.config.complete);
            }
            else {
                this.schain[si].config.complete = null;
            }
        });
        //Server Side
        if (this.permission["control_center-view_demand_partners--server"] &&
            this.server.enabled &&
            this.server.demandPartners.length < 1) {
            modelWarnings += `<li>${this.bidder.name} needs to either have a Server Side Demand Partner or to have it's Server Side turned off </li>`;
        }
        for (let partner of this.server.demandPartners) {
            let fields = partner.fields && partner.fields.length > 0
                ? JSON.parse(JSON.stringify(this._versionPipe.transform(partner.fields, this.versions.adEngine)))
                : [];
            for (let field in fields) {
                if (fields[field].required || fields[field].value) {
                    if (typeof fields[field].value == "undefined") {
                        modelWarnings += `<li> Server Side Demand Partner "${partner.displayName}" is missing a required field ${fields[field].name}</li>`;
                    }
                    else {
                        switch (fields[field].type) {
                            case "boolean":
                                if (fields[field].value != "true" &&
                                    fields[field].value != "false") {
                                    modelWarnings += `<li> Server Side Demand Partner "${partner.displayName}" had a field ${fields[field].name} that should be a boolean but is not</li>`;
                                }
                                break;
                            case "numeric":
                                if (parseFloat(fields[field].value) != fields[field].value) {
                                    modelWarnings += `<li> Server Side Demand Partner "${partner.displayName}" had a field ${fields[field].name} that should be a number but is not</li>`;
                                }
                                break;
                            case "object":
                                if (!(Object.keys(JSON.parse(fields[field].value)).length > 0)) {
                                    modelWarnings += `<li> Server Side Demand Partner "${partner.displayName}" had a field ${fields[field].name} that should be an object{} but is not</li>`;
                                }
                                break;
                            case "array":
                                try {
                                    JSON.parse(fields[field].value);
                                }
                                catch (e) {
                                    modelWarnings += `<li>Server Side Demand Partner "${partner.displayName}" had a field ${fields[field].name} that should be an array[] of ${fields[field].subType} but is not</li>`;
                                    break;
                                }
                                const arrVal = JSON.parse(fields[field].value);
                                if (!Array.isArray(arrVal) ||
                                    !(arrVal.length || arrVal.length > 0)) {
                                    modelWarnings += `<li>Server Side Demand Partner "${partner.displayName}" had a field ${fields[field].name} that should be an array[] but is not</li>`;
                                }
                                else {
                                    for (let val in arrVal) {
                                        switch (fields[field].subtype) {
                                            case "numeric":
                                                if (parseFloat(arrVal[val]) != arrVal[val]) {
                                                    modelWarnings += `<li>Server Side Demand Partner "${partner.displayName}" had a field ${fields[field].name} that should be a number but is not</li>`;
                                                }
                                                break;
                                            case "object":
                                                if (!Object.keys(JSON.parse(arrVal[val]).length > 0)) {
                                                    modelWarnings += `<li>Server Side Demand Partner "${partner.displayName}" had a field ${fields[field].name} that should be an object{} but is not</li>`;
                                                }
                                                break;
                                        }
                                    }
                                }
                                break;
                        }
                    }
                }
            }
        }
        //Price Buckets
        let MIN = this._priceBucket.getMin(), MAX = this._priceBucket.getMax();
        for (let pB = 0; pB < this.priceBuckets.length; pB++) {
            let nextPriceBucket;
            let tier = Number(this.priceBuckets[pB].tier);
            let pbi = Number(this.priceBuckets[pB].pbi);
            if (this.priceBuckets[pB + 1]) {
                nextPriceBucket = this.priceBuckets[pB + 1].tier;
            }
            else {
                nextPriceBucket = MAX;
            }
            //check min and max versus current values (and if current values exist)
            if (!tier || tier < MIN) {
                modelWarnings +=
                    `<li>Price Bucket Tier ` +
                        tier +
                        ` must be a valid number (>= ` +
                        MIN +
                        `)</li>`;
            }
            else if (tier > MAX) {
                modelWarnings +=
                    `<li>Price Bucket Tier ` +
                        tier +
                        ` must be a valid number (<= ` +
                        MAX +
                        `)</li>`;
            }
            if (!pbi || pbi < MIN) {
                modelWarnings +=
                    `<li>Price Bucket Increment ` +
                        pbi +
                        ` must be a valid number (>= ` +
                        MIN +
                        `)</li>`;
            }
            else if (pbi > MAX) {
                modelWarnings +=
                    `<li>Price Bucket Increment ` +
                        pbi +
                        ` must be a valid number (<= ` +
                        MAX +
                        `)</li>`;
            }
            // check value (granularity) doesn't exceed next tier
            if (tier + pbi > nextPriceBucket) {
                if (nextPriceBucket != MAX) {
                    modelWarnings +=
                        `<li>Price Bucket Tier (` +
                            tier +
                            `) + PBG (` +
                            pbi +
                            `) cannot exceed next Tier (` +
                            nextPriceBucket +
                            `)</li>`;
                }
                else {
                    modelWarnings +=
                        `<li>Price Bucket Tier (` +
                            tier +
                            `) + PBG (` +
                            pbi +
                            `) cannot exceed (` +
                            MAX +
                            `)</li>`;
                }
            }
            // check if hardFloor intersects bucket. This is allowed but we should notify the user (BRTCFD-492).
            if (this.hardFloor >= tier)
                hardFloorNotification = true;
        }
        if (!this.timeout.isStatic) {
            if (this.timeout.minTimeout < this.MIN_TIMEOUT ||
                this.timeout.minTimeout > this.MAX_TIMEOUT) {
                modelWarnings +=
                    `<li>Your Min Timeout of ` +
                        this.timeout.minTimeout +
                        `ms should be between ` +
                        this.MIN_TIMEOUT +
                        ` and ` +
                        this.MAX_TIMEOUT +
                        `</li>`;
            }
            if (this.timeout.maxTimeout < this.MIN_TIMEOUT ||
                this.timeout.maxTimeout > this.MAX_TIMEOUT) {
                modelWarnings +=
                    `<li>Your Max Timeout of ` +
                        this.timeout.maxTimeout +
                        `ms should be between ` +
                        this.MIN_TIMEOUT +
                        ` and ` +
                        this.MAX_TIMEOUT +
                        `</li>`;
            }
            if (this.timeout.fastBandwidth < 0.025 ||
                this.timeout.fastBandwidth > 10) {
                modelWarnings +=
                    `<li>Your Fast Bandwidth Cutoff ` +
                        this.timeout.fastBandwidth +
                        `Mbps should be between .025 and 10</li>`;
            }
            if (this.timeout.slowBandwidth < 0.025 ||
                this.timeout.slowBandwidth > 10) {
                modelWarnings +=
                    `<li>Your Slow Bandwidth Cutoff ` +
                        this.timeout.slowBandwidth +
                        `Mbps should be between .025 and 10</li>`;
            }
        }
        else {
            if (this.timeout.staticTimeout < this.MIN_TIMEOUT ||
                this.timeout.staticTimeout > this.MAX_TIMEOUT) {
                modelWarnings +=
                    `<li>Your Static Timeout of ` +
                        this.timeout.staticTimeout +
                        `ms should be between ` +
                        this.MIN_TIMEOUT +
                        ` and ` +
                        this.MAX_TIMEOUT +
                        `</li>`;
            }
            if (this.timeout.staticTimeout != Math.ceil(this.timeout.staticTimeout)) {
                modelWarnings +=
                    `<li>Your Static Timeout of ` +
                        this.timeout.staticTimeout +
                        `ms must be an integer.  Decimals are not allowed.</li>`;
            }
        }
        if (this.dAUTF && !this.dAUT) {
            modelWarnings += `<li>Dynamic Ad Unit Targeting Fallback cannot be turned on if Dynamic Ad Unit Targeting itself is not turned on</li>`;
        }
        if (this.onlyTargetSlotDivId == true && this.onlyTargetSlotCode == true) {
            modelWarnings += `<li>You cannot only target slot Div Ids and only target slot Codes. Only one option can be selected</li>`;
        }
        if (this.enforceGDPRDemandPartners == true &&
            this.enforceTCF2DemandPartners == true) {
            modelWarnings += `<li>You cannot enforce GDPR and GDPR/TCF2 Demand Partners together. Only one option can be selected</li>`;
        }
        if (modelWarnings) {
            this._talk.broadcast(`<ul [innerHTML]="modelWarnings"></ul> Please correct the following issues:\n` +
                modelWarnings);
            return Promise.resolve(false);
        }
        if (hardFloorNotification) {
            // make user aware of changes that are allowed but may not have been intentional
            this._talk
                .confirm(`Your Hard Floor is currently greater than one or many of your Price Bucket tier/s. Those corresponding line
        items within that Price Bucket tier/s will not activate if they are below  the Hard Floor. Please note that no
        action needs to be taken on your Price Buckets or to the line items inside of your Ad Server.`)
                .then((dialog) => dialog.result)
                .then(() => {
                return parseSaveData.call(this);
            })
                .catch((err) => {
                if (err)
                    console.log(err);
            });
        }
        else {
            // save without confirmation dialog if there are no notifications
            return parseSaveData.call(this);
        }
        function parseSaveData() {
            //PARSING DATA FOR SAVE
            //Price Buckets
            for (var pbs in this.priceBuckets) {
                this.priceBuckets[pbs].min = this._decimalPipe.transform(this.priceBuckets[pbs].tier, "1.2-2"); //TODO: REPLACE OLD NAMING
                this.priceBuckets[pbs].value = this._decimalPipe.transform(this.priceBuckets[pbs].pbi, "1.2-2");
                delete this.priceBuckets[pbs].pbi;
                delete this.priceBuckets[pbs].tier;
            }
            //Bid CPM Adjustments
            var storeBidCPMAdjustments = { server: {} };
            for (var bidCPM in this.bidCPMAdjustments) {
                if (this.bidCPMAdjustments[bidCPM].value != 100) {
                    if (this.bidCPMAdjustments[bidCPM].type.type != "server") {
                        storeBidCPMAdjustments[this.bidCPMAdjustments[bidCPM].code] =
                            this.bidCPMAdjustments[bidCPM].value / 100;
                    }
                    else {
                        storeBidCPMAdjustments.server[this.bidCPMAdjustments[bidCPM].code] =
                            this.bidCPMAdjustments[bidCPM].value / 100;
                    }
                }
            }
            //Ad Units
            var storeAdUnits = [];
            for (let aU in this.adUnits) {
                let adUnit = JSON.parse(JSON.stringify(this.adUnits[aU]));
                var sizesUnit = this._size.changeIdsToSizes(adUnit.sizes);
                if (adUnit.sizeMapping.devices.length > 0) {
                    let devices = adUnit.sizeMapping.devices;
                    for (let device in devices) {
                        if (devices[device].sizes) {
                            devices[device].sizes = this._size.changeIdsToSizes(devices[device].sizes);
                        }
                    }
                }
                var demandPartners = [];
                for (var mDP in adUnit.demandPartners.client) {
                    // Filter fields for invalid values
                    const fields = adUnit.demandPartners.client[mDP].fields.filter((field) => {
                        return (field.value !== null &&
                            field.value !== "" &&
                            (!field.maxVersion ||
                                this.versions.adEngine <= field.maxVersion));
                    });
                    var mDPP = {}; //output object for fields
                    for (var f in fields) {
                        if (typeof fields[f].value != "undefined") {
                            if (typeof fields[f].value == "string") {
                                fields[f].value = fields[f].value.trim();
                            }
                            mDPP[fields[f].name] = fields[f].value;
                            switch (fields[f].type) {
                                case "numeric":
                                    mDPP[fields[f].name] = parseFloat(mDPP[fields[f].name]);
                                    break;
                                case "string":
                                    mDPP[fields[f].name] = mDPP[fields[f].name].toString();
                                    break;
                                case "object":
                                    if (typeof mDPP[fields[f].name] != "undefined" &&
                                        mDPP[fields[f].name] != "") {
                                        mDPP[fields[f].name] = JSON.parse(JSON.stringify(mDPP[fields[f].name]));
                                    }
                                    break;
                                case "array":
                                    if (typeof mDPP[fields[f].name] != "undefined" &&
                                        mDPP[fields[f].name] != "") {
                                        mDPP[fields[f].name] = JSON.parse(mDPP[fields[f].name]);
                                        break;
                                    }
                            }
                        }
                    }
                    demandPartners.push({
                        adUnit: this.isCopy ? null : adUnit.id || null,
                        demandPartner: adUnit.demandPartners.client[mDP].id,
                        id: this.isCopy
                            ? null
                            : adUnit.id
                                ? adUnit.demandPartners.client[mDP].adUnitPartnerId
                                : null,
                        enabled: adUnit.demandPartners.client[mDP].enabled,
                        params: mDPP,
                        position: parseInt(mDP),
                    });
                }
                storeAdUnits.push({
                    id: this.isCopy ? undefined : adUnit.id,
                    guid: this.isCopy ? undefined : adUnit.guid,
                    bidder: this.isCopy ? null : this.bidder.id || null,
                    displayName: adUnit.displayName.trim(),
                    code: adUnit.code.trim(),
                    div: adUnit.div.trim(),
                    sizes: sizesUnit,
                    sizeMapping: adUnit.sizeMapping,
                    demandPartners: demandPartners,
                    hardFloor: parseFloat(adUnit.hardFloor),
                    //"serverBids": [],
                    enabled: adUnit.enabled,
                    clientEnabled: adUnit.clientEnabled,
                    serverEnabled: adUnit.serverEnabled,
                    randomizeDemandPartner: adUnit.randomizeDemandPartner,
                });
            }
            let createdId = this.bidder.createdBy === undefined
                ? this._user.get().id
                : this.bidder.createdBy.id;
            // Add Bid schain adjustment
            if (this.schainPermission) {
                this.bidder.schainConfig = {
                    enabled: this.schainEnabled,
                    demandPartners: this.schain,
                };
            }
            else {
                this.bidder.schainConfig = null;
            }
            //JSON BUILD
            this._loading.start("Saving Bidder...");
            var payload = {
                name: this.bidder.name,
                client: this.bidder.client.id,
                id: this.isCopy ? null : this.bidder.id || null,
                createdBy: createdId,
                updatedBy: this._user.get().id,
                unminified: this.bidder.unminified, //true
                adUnits: storeAdUnits,
                controlCenterVersion: this.isCopy ? "" : this.versions.controlCenter,
                engineVersion: this.versions.adEngine,
                bidAdjustments: storeBidCPMAdjustments,
                schainConfig: this.bidder.schainConfig,
                server: this.server,
                integrations: {
                    enableServices: this.enableServices,
                    dAUT: this.dAUT,
                    dAUTF: this.dAUTF,
                    instantAuction: this.instantAuction,
                    onlyTargetSlotDivId: this.onlyTargetSlotDivId,
                    onlyTargetSlotCode: this.onlyTargetSlotCode,
                    queRefresh: this.queRefresh,
                    guaranteedRefresh: this.guaranteedRefresh,
                    immediateFirePixel: this.immediateFirePixel,
                    enableLineItemAutomation: this.enableLineItemAutomation,
                    refresh: true,
                    refreshOption: this.refreshOption,
                    internalRefresh: this.internalRefresh,
                    pubCommonId: this.pubCommonId,
                    randomizeDemandPartner: !!this.randomizeDemandPartner,
                    gptInstantLoad: this.gptInstantLoad,
                    biddr3x: this.biddr3x,
                    biddr4: this.biddr4,
                    waitForSlotDefinition: this.waitForSlotDefinition,
                    adUnitHardFloor: this.integration.adUnitHardFloor,
                    newUnitGeneration: this.newUnitGeneration,
                    castTAsInteger: this.castTAsInteger,
                    enforceGDPRDemandPartners: this.enforceGDPRDemandPartners,
                    enforceTCF2DemandPartners: this.enforceTCF2DemandPartners,
                    enforceCCPADemandPartners: this.enforceCCPADemandPartners,
                },
                timeout: this.parseTimeoutData(this.timeout),
                hardFloor: parseFloat(this.hardFloor),
                priceBuckets: this.priceBuckets,
                sizeGUID: sizeGUIDs,
                bidderGUID: demandPartnerGUIDs,
            };
            console.log(payload);
            let bidderChanges = this._bidder.compare(this.bidder.id, payload);
            // Fire events - we will ultimately want to move this inside of the promise
            if (this._router.url === "/controlcenter/new" || this.isCopy) {
                this.events.add({
                    subFeature: events_1.EventSubFeature.bidder,
                    action: events_1.EventAction.added,
                });
            }
            return Promise.resolve(this._bidder.save(payload))
                .then((res) => {
                if (res instanceof Array) {
                    res = res[0];
                }
                if (res && res.id) {
                    //Check if we can Start line item automation DFP verification
                    if (this.enableLineItemAutomation && this.lineItemAutomation) {
                        this.lineItemAutomation.startLineItemServiceVerify({
                            priceBucketConfig: this.priceBuckets,
                            adUnits: storeAdUnits,
                            sizesChanges: this._bidder.checkNewSizesChanges(bidderChanges),
                            bidder: this.bidder.id || res.id,
                        });
                    }
                    Promise.resolve(this._bidder.getBidders()).then((err) => {
                        this._loading.stop();
                        this.events.batchCreate();
                        if (!this.bidder.iID || this.isCopy) {
                            return Promise.resolve((this.bidder.iID = res.iID)).then((err) => {
                                this.adUnitsDisplay = false;
                                this.advOptionsDisplay = false;
                                if (showSavedAlert)
                                    this._talk.broadcast(`Saved Successfully!  The HTML script tag to insert into your code is located under the "Bidder Information" header`);
                                this.permission["control_center-remove_change_detection"] =
                                    true;
                                this._router.navigate(["controlcenter/edit", res.id]);
                            });
                        }
                        else {
                            var message = "Saved Successfully! ";
                            if (res.updateRestricted) {
                                message = `Bidder update was restricted. The ${res.updateRestricted.message}. Restriction Code: ${res.updateRestricted.code}`;
                            }
                            if (showSavedAlert)
                                this._talk.broadcast(message);
                            return this._bidder.getBidderDetail(res.id).then((bidder) => {
                                this.selectedBidder = bidder;
                                this.setBidder();
                                this.loadInitConfigs(bidder.id);
                            });
                        }
                    });
                }
                return true;
            })
                .catch((err) => this.handleBidderSaveError(err));
        }
    }
    staticTimeoutChanged() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            context: "static-timeout",
            action: events_1.EventAction.changed,
            subject: this.timeout["staticTimeout"],
        });
    }
    minTimeoutChanged() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            context: "min-timeout",
            action: events_1.EventAction.changed,
            subject: this.timeout["minTimeout"],
        });
    }
    maxTimeoutChanged() {
        this.events.add({
            subFeature: events_1.EventSubFeature.advancedOption,
            context: "max-timeout",
            action: events_1.EventAction.changed,
            subject: this.timeout["maxTimeout"],
        });
    }
    handleBidderSaveError(err) {
        let errBody;
        try {
            errBody = err.json();
        }
        catch (e) {
            errBody = err;
        }
        if (err.status == 403) {
            this._talk.broadcast(`Oops. It looks like you don't have permission to save <i class="fa fa-frown-o" aria-hidden="true"></i>`);
        }
        else {
            this._talk.broadcast(`
      <p>Oops! There was a problem saving this bidder.</p>
      <p>Error Code: <strong>${errBody.code || "Unknown"}</strong></p>
      <p>Please verify the values and try again or if the problem persist submit a support request.</p>`);
            this._talk.handle(err);
        }
        this._loading.stop();
        if (this.bidder.id)
            this.loadInitConfigs(this.bidder.id);
    }
    parseTimeoutData(timeout) {
        if (timeout.isStatic) {
            return { type: "static", staticTimeout: timeout.staticTimeout };
        }
        else {
            let timeoutMap = {};
            if (timeout.maxTimeout > 6000)
                timeout.maxTimout = 6000;
            if (timeout.fastBandwidth > 5)
                timeout.fastBandwidth = 5;
            for (var k = timeout.slowBandwidth; k < timeout.fastBandwidth * 10; k++) {
                var yData = timeout.maxTimeout * Math.pow(1 - 0.1, k);
                yData < timeout.minTimeout ? (yData = timeout.minTimeout) : null;
                var xData = (0.25 * k).toFixed(2);
                if (xData < timeout.fastBandwidth)
                    timeoutMap[xData] = yData;
            }
            return {
                type: "dynamic",
                fastBandwidth: timeout.fastBandwidth,
                slowBandwidth: timeout.slowBandwidth,
                maxTimeout: timeout.maxTimeout,
                minTimeout: timeout.minTimeout,
                timeoutMap,
            };
        }
    }
    //Changelog
    sortChangelog(sortBy) {
        if (this.sortChangelogList == sortBy) {
            this.sortChangelogMod = !this.sortChangelogMod;
        }
        else {
            this.sortChangelogList = sortBy;
            this.sortChangelogMod = true;
        }
        let order = this.sortChangelogMod ? -1 : 1;
        if (sortBy === "oldGenerator" || sortBy === "oldAdEngine") {
            this.bidder.changeLog.sort((v1, v2) => {
                return order * v1[sortBy].cmp(v2[sortBy]);
            });
        }
        else {
            this.bidder.changeLog.sort((a, b) => {
                return order * order_by_pipe_1.OrderByPipe._orderByComparator(a[sortBy], b[sortBy]);
            });
        }
    }
    showChanges(revision) {
        this.modal
            .open(changelog_modal_component_1.ChangeLogModalComponent, (0, angular2_modal_1.overlayConfigFactory)({ revision: revision }))
            .then((dialogRef) => {
            dialogRef.result.then((revision) => {
                if (revision) {
                    this.revertToRevision(revision);
                    this.showMenu = false;
                }
            });
        });
    }
    revertToRevision(revision) {
        this.loadBidderJson(revision);
        this.showMenu = false;
        this._talk.broadcast(`Reverted to the version saved by ${revision.updatedBy} at ${revision.updatedAt}.`);
    }
    loadLineItemConfigValues(bidder) {
        if (this.enableLineItemAutomation && this.lineItemAutomation && bidder) {
            setTimeout(() => {
                this.lineItemAutomation.loadInitialValues(bidder);
            }, 0);
        }
    }
    onTriggerBidderSave() {
        this.save(false);
    }
    verifyBidderState(bidder) {
        if (bidder.deleted)
            return { status: "deleted", restricted: true };
        if (bidder.paused)
            return { status: "paused", restricted: true };
        if (!this.isCopy && bidder.lock && bidder.lock.enabled)
            return { status: "locked", restricted: true };
        return { status: "", restricted: false };
    }
    displayBidderRestrictionAlert(restriction, bidder) {
        this._talk.broadcast(`
      <p>This Bidder is currently ${restriction.status}, you may still view the Bidder but you will not be able to save any changes made.
      If you have any questions about ${bidder.name} being ${restriction.status} please reach out to support at <strong>contactaperturemx@cadent.tv</strong>.</p>
    `);
    }
    sortArrayBy(array, sortKey) {
        return array.sort((pA, pB) => pA[sortKey] - pB[sortKey]);
    }
    schainHelp() {
        var schainSample = {
            schain: {
                validation: "relaxed",
                config: {
                    ver: "1.0",
                    complete: 1,
                    nodes: [
                        {
                            asi: "bidderA.com",
                            sid: "00001",
                            hp: 1,
                        },
                    ],
                },
            },
        };
        let formatedSample = JSON.stringify(schainSample, undefined, 6).replace(/\n( *)/g, function (match, p1) {
            return "<br>" + "&nbsp;".repeat(p1.length);
        });
        this._talk.broadcast(`As part of a broader effort to eliminate the ability to profit from invalid traffic, ad fraud, and counterfeit inventory in the open digital advertising ecosystem, the SupplyChain object enables buyers to see all parties who are selling or reselling a given bid request. This extension object can be used with OpenRTB 2.5 or OpenRTB 3.0. 
       <h5><b>Sample Schain Config</b></h5>${formatedSample}`);
        this.events.add({
            subFeature: events_1.EventSubFeature.help,
            action: events_1.EventAction.clicked,
            subject: "schain",
        });
    }
    createSchainForm() {
        this.schainForm = new forms_1.FormGroup({
            validation: new forms_1.FormControl(this.validationOption[0], [
                forms_1.Validators.required,
                this.noWhitespaceValidator,
            ]),
            ver: new forms_1.FormControl("", [
                forms_1.Validators.required,
                this.noWhitespaceValidator,
            ]),
            complete: new forms_1.FormControl("", [
                forms_1.Validators.required,
                this.noWhitespaceValidator,
            ]),
            asi: new forms_1.FormControl("", [
                forms_1.Validators.required,
                this.noWhitespaceValidator,
            ]),
            sid: new forms_1.FormControl("", [
                forms_1.Validators.required,
                this.noWhitespaceValidator,
            ]),
            hp: new forms_1.FormControl("", [
                forms_1.Validators.required,
                this.noWhitespaceValidator,
            ]),
            rid: new forms_1.FormControl(""),
            name: new forms_1.FormControl(""),
            domain: new forms_1.FormControl(""),
        });
    }
    noWhitespaceValidator(control) {
        const isWhitespace = (control.value ? control.value.toString() : "").trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { whitespace: true };
    }
    importSchain(schain) {
        let defaultSchain = schain.demandPartners || [];
        let defaultDP = [];
        let addedDP = [];
        this.schain = [];
        if (!this.isCopy && defaultSchain.length > 0) {
            this.schainEnabled = schain.enabled;
            defaultDP = defaultSchain.map((dP) => dP.code);
        }
        else {
            defaultSchain = [];
        }
        let types = ["client", "server"];
        for (let aU in this.adUnits) {
            for (let t in types) {
                for (let dP of this.adUnits[aU].demandPartners[types[t]]) {
                    if (addedDP.indexOf(dP.code) === -1) {
                        if (defaultDP.indexOf(dP.code) === -1 && dP.schain) {
                            addedDP.push(dP.code);
                            defaultDP.push(dP.code);
                            this.schain.push({
                                code: dP.code,
                                config: this.schainForm.value,
                                enabled: true,
                                valid: false,
                            });
                        }
                        else if (defaultDP.indexOf(dP.code) >= 0 && dP.schain) {
                            defaultSchain.forEach((sDP) => {
                                if (sDP.code === dP.code) {
                                    addedDP.push(dP.code);
                                    defaultDP.push(dP.code);
                                    this.schain.push(sDP);
                                }
                            });
                        }
                    }
                }
            }
        }
    }
    selectSchainDemandPartners() {
        if (this.schainSelection.length > 0) {
            this.schainSelection = [];
        }
        else {
            this.schain.forEach((dp) => {
                if (dp && dp.code) {
                    this.schainSelection.push(dp.code);
                }
            });
        }
    }
    checkedSchainBidder(partnerCode) {
        let index = this.schainSelection.indexOf(partnerCode);
        if (index === -1) {
            this.schainSelection.push(partnerCode);
        }
        else if (index != -1) {
            this.schainSelection.splice(index, 1);
        }
    }
    openSchainConfigModal() {
        if (!this.schainFormModal) {
            this.createSchainForm();
            let selectedCode = this.schainSelection;
            if (selectedCode.length === 1) {
                this.schain.forEach((dP) => {
                    if (dP.code === selectedCode[0]) {
                        let { validation, ver, complete, asi, sid, hp, rid, name, domain } = dP.config;
                        let validationValue = this.validationOption.indexOf(validation) === -1
                            ? this.validationOption[0]
                            : validation;
                        this.schainForm.patchValue({
                            validation: validationValue,
                            ver,
                            complete,
                            asi,
                            sid,
                            hp,
                            rid,
                            name,
                            domain,
                        });
                    }
                });
            }
            this.schainFormModal = true;
        }
    }
    closeSchainConfigModal() {
        this.schainSelection = [];
        this.schainFormModal = false;
        this.schainForm.reset();
    }
    addSchainValueOfDemandPartner() {
        this.schain.forEach((dP, index) => {
            if (isNaN(this.schainForm.value.complete)) {
                this.schainForm.patchValue({ complete: null });
            }
            if (isNaN(this.schainForm.value.hp)) {
                this.schainForm.patchValue({ hp: null });
            }
            if (this.schainSelection.indexOf(dP.code) > -1) {
                this.schain[index].config = this.schainForm.value;
                this.schain[index].valid = this.schainForm.valid;
            }
        });
        this.closeSchainConfigModal();
    }
    getLogoDetails(partnerCode) {
        let logos = [];
        let types = ["client", "server"];
        let logoDpCode = [];
        for (let aU in this.adUnits) {
            for (let t in types) {
                for (let dP of this.adUnits[aU].demandPartners[types[t]]) {
                    if (partnerCode) {
                        if (partnerCode == dP.code) {
                            return {
                                logo: dP.logo,
                                name: dP.displayName || dP.code,
                            };
                        }
                    }
                    else if (this.schainSelection.indexOf(dP.code) > -1 &&
                        logoDpCode.indexOf(dP.code) === -1) {
                        logoDpCode.push(dP.code);
                        logos.push({
                            logo: dP.logo,
                            name: dP.displayName || dP.code,
                        });
                    }
                }
            }
        }
        return logos;
    }
};
exports.EditBidderComponent = EditBidderComponent;
__decorate([
    (0, core_1.ViewChild)("priceBucketContainer"),
    __metadata("design:type", core_1.ElementRef)
], EditBidderComponent.prototype, "priceBucketContainerElement", void 0);
__decorate([
    (0, core_1.ViewChild)("lineItemAutomation"),
    __metadata("design:type", lineitem_automation_component_1.LineItemAutomationComponent)
], EditBidderComponent.prototype, "lineItemAutomation", void 0);
exports.EditBidderComponent = EditBidderComponent = __decorate([
    (0, core_1.Component)({
        selector: "my-edit-bidder",
        templateUrl: "app/bidder.component.html",
        styleUrls: ["styles/bidder.component.css"],
    }),
    __metadata("design:paramtypes", [common_1.DecimalPipe,
        version_pipe_1.VersionPipe,
        router_1.ActivatedRoute,
        bidder_service_1.BidderService,
        demand_partner_service_1.DemandPartnerService,
        demand_partner_type_service_1.DemandPartnerTypeService,
        user_service_1.UserService,
        permission_service_1.PermissionService,
        version_service_1.VersionService,
        clients_service_1.ClientsService,
        notification_service_1.NotificationService,
        router_1.Router,
        check_key_pipe_1.CheckKeyPipe,
        core_1.ChangeDetectorRef,
        core_1.ApplicationRef,
        size_service_1.SizeService,
        price_bucket_service_1.PriceBucketService,
        loading_service_1.LoadingService,
        integration_service_1.IntegrationService,
        platform_browser_1.Title,
        demand_partner_menu_service_1.DemandPartnerMenuService,
        can_deactivate_guard_service_1.CanDeactivateGuardService,
        notifier_service_1.NotifierService,
        changelog_service_1.ChangeLogService,
        bootstrap_1.Modal,
        common_1.Location,
        ad_unit_service_1.AdUnitService,
        branding_service_1.BrandingService])
], EditBidderComponent);
//# sourceMappingURL=bidder.component.js.map